import { OnyxAddressType } from '@onyx/angular';
import { OrderPointType } from '../../../dashboard/orders/common/enums/order-point-type';
import type { TransitPoint } from '../../interfaces/transit/transit-point';

export const FERRIES = {
  /* Albania */
  durres: {
    id: 'durres',
    type: OrderPointType.FERRY,
    name: 'Durres',
    address: {
      label: 'Rruga Pavaresia 66, 2000 Durrës, AL',
      street: 'Rruga Pavaresia',
      houseNumber: '66',
      apartmentNumber: null,
      zipCode: '2000',
      city: 'Durrës',
      countryCode: 'al',
      coordinates: {
        latitude: 41.3139205929414,
        longitude: 19.45579809472036,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Durres Port',
    },
    phone: {
      areaCode: '+355',
      number: '52223115',
    },
  },
  valona: {
    id: 'valona',
    type: OrderPointType.FERRY,
    name: 'Valona',
    address: {
      label: '9401 Vlora, AL',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '9401',
      city: 'Vlora',
      countryCode: 'al',
      coordinates: {
        latitude: 40.449231411176065,
        longitude: 19.480754953023354,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Vlora Port',
    },
    phone: {
      areaCode: '+355',
      number: '692079439',
    },
  },

  /* Algeria */
  // TODO

  /* Balearic Islands */
  alcudia: {
    id: 'alcudia',
    type: OrderPointType.FERRY,
    name: 'Alcudia',
    address: {
      label: '07400 Alcúdia, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '07400',
      city: 'Alcúdia',
      countryCode: 'es',
      coordinates: {
        latitude: 39.835590765248334,
        longitude: 3.139806181135763,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port Alcudia',
    },
    phone: null,
  },
  ciutadella: {
    id: 'ciutadella',
    type: OrderPointType.FERRY,
    name: 'Ciutadella',
    address: {
      label: '07760 Ciudadela de Menorca, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '07760',
      city: 'Ciutadella',
      countryCode: 'es',
      coordinates: {
        latitude: 39.98829052164067,
        longitude: 3.826979493998723,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Ciutadella - Port de Ciutadella',
    },
    phone: {
      areaCode: '+34',
      number: '912660215',
    },
  },
  ibiza: {
    id: 'ibiza',
    type: OrderPointType.FERRY,
    name: 'Ibiza',
    address: {
      label: 'Carrer Botafoch, 07800 Ibiza, ES',
      street: 'Carrer Botafoch',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '07800',
      city: 'Ibiza',
      countryCode: 'es',
      coordinates: {
        latitude: 38.90669725990917,
        longitude: 1.4529999560190472,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Eivissa - Estació Marítima del Botafoc',
    },
    phone: null,
  },
  mahon: {
    id: 'mahon',
    type: OrderPointType.FERRY,
    name: 'Mahon',
    address: {
      label: '07701 Mahon, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '07701',
      city: 'Mahon',
      countryCode: 'es',
      coordinates: {
        latitude: 39.89039125519802,
        longitude: 4.266746605634898,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Mahon Port',
    },
    phone: null,
  },
  palmaMallorca: {
    id: 'palma-mallorca',
    type: OrderPointType.FERRY,
    name: 'Palma Mallorca',
    address: {
      label: '07015 Palma, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '07015',
      city: 'Palma',
      countryCode: 'es',
      coordinates: {
        latitude: 39.55345823861948,
        longitude: 2.6292180994998744,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Palma de Mallorca',
    },
    phone: null,
  },

  /* Belgium */
  antwerp: {
    id: 'antwerp',
    type: OrderPointType.FERRY,
    name: 'Antwerp',
    address: {
      label: 'Land van Waaslaan 5, 9130 Beveren, BE',
      street: 'Land van Waaslaan',
      houseNumber: '5',
      apartmentNumber: null,
      zipCode: '9130',
      city: 'Antwerp',
      countryCode: 'be',
      coordinates: {
        latitude: 51.26388334240038,
        longitude: 4.2463976485137005,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Land van Waaslaan 5',
    },
    phone: null,
  },
  ghent: {
    id: 'ghent',
    type: OrderPointType.FERRY,
    name: 'Ghent',
    address: {
      label: 'Philips Landsbergiuslaan 11, 9000 Ghent, BE',
      street: 'Philips Landsbergiuslaan',
      houseNumber: '11',
      apartmentNumber: null,
      zipCode: '9000',
      city: 'Ghent',
      countryCode: 'be',
      coordinates: {
        latitude: 51.11908145868108,
        longitude: 3.767190150498877,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Philips Landsbergiuslaan 11',
    },
    phone: null,
  },
  ostend: {
    id: 'ostend',
    type: OrderPointType.FERRY,
    name: 'Ostend',
    address: {
      label: 'Maritiem Plein, 8400 Ostend, BE',
      street: 'Maritiem Plein',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '8400',
      city: 'Ostend',
      countryCode: 'be',
      coordinates: {
        latitude: 51.23422280240092,
        longitude: 2.926708477943179,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Overzetboot Oosteroever - Visserskaai',
    },
    phone: null,
  },
  zeebrugge: {
    id: 'zeebrugge',
    type: OrderPointType.FERRY,
    name: 'Zeebrugge',
    address: {
      label: 'Doverlaan 7, 8380 Brugge, BE',
      street: 'Doverlaan',
      houseNumber: '7',
      apartmentNumber: null,
      zipCode: '8380',
      city: 'Brugge',
      countryCode: 'be',
      coordinates: {
        latitude: 51.33161296966428,
        longitude: 3.1853168531536262,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Doverlaan 7',
    },
    phone: null,
  },

  /* Bulgaria */
  burgas: {
    id: 'burgas',
    type: OrderPointType.FERRY,
    name: 'Burgas',
    address: {
      label: 'Knyaz Alexander Batenberg 2, 8000 Burgas, BG',
      street: 'Knyaz Alexander Batenberg',
      houseNumber: '2',
      apartmentNumber: null,
      zipCode: '8000',
      city: 'Burgas',
      countryCode: 'bg',
      coordinates: {
        latitude: 42.4905620735684,
        longitude: 27.47944512391355,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Burgas Center, ul. "Knyaz Alexander Batenberg" 2',
    },
    phone: null,
  },
  varna: {
    id: 'varna',
    type: OrderPointType.FERRY,
    name: 'Varna',
    address: {
      label: 'Sq. Slaveykov 1, Varna, BG',
      street: 'Sq. Slaveykov',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '-',
      city: 'Varna',
      countryCode: 'bg',
      coordinates: {
        latitude: 43.19703391248578,
        longitude: 27.914782087742182,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port Varna',
    },
    phone: {
      areaCode: '+359',
      number: '52692508',
    },
  },

  /* Canary Islands */
  arrecife: {
    id: 'arrecife',
    type: OrderPointType.FERRY,
    name: 'Arrecife',
    address: {
      label: 'Avenida de los Marmoles 4-38, 35500 Arrecife, ES',
      street: 'Avenida de los Marmoles',
      houseNumber: '4-38',
      apartmentNumber: null,
      zipCode: '35500',
      city: 'Arrecife',
      countryCode: 'es',
      coordinates: {
        latitude: 28.97123807550992,
        longitude: -13.526337726396287,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Arrecife',
    },
    phone: null,
  },
  lasPalmasGranCanaria: {
    id: 'las-palmas-gran-canaria',
    type: OrderPointType.FERRY,
    name: 'Las Palmas Gran Canaria',
    address: {
      label: 'Muelle Nelson Mandela s/n, 35008 Las Palmas de Gran Canaria, ES',
      street: 'Muelle Nelson Mandela',
      houseNumber: 's/n',
      apartmentNumber: null,
      zipCode: '35008',
      city: 'Las Palmas de Gran Canaria',
      countryCode: 'es',
      coordinates: {
        latitude: 28.16086658291104,
        longitude: -15.401549473382351,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Arrecife',
    },
    phone: {
      areaCode: '+34',
      number: '902456500',
    },
  },
  puertoRosario: {
    id: 'puerto-rosario',
    type: OrderPointType.FERRY,
    name: 'Puerto Rosario',
    address: {
      label: '35600 Puerto del Rosario, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '35600',
      city: 'Puerto del Rosario',
      countryCode: 'es',
      coordinates: {
        latitude: 28.4985354,
        longitude: -13.8561643,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Naviera Armas Oficina de Puerto del Rosario',
    },
    phone: {
      areaCode: '+34',
      number: '902456500',
    },
  },
  santaCruzDeLaPalma: {
    id: 'santa-cruz-de-la-palma',
    type: OrderPointType.FERRY,
    name: 'Santa Cruz de La Palma',
    address: {
      label: '38700 Santa Cruz de La Palma, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '38700',
      city: 'Santa Cruz de La Palma',
      countryCode: 'es',
      coordinates: {
        latitude: 28.677801,
        longitude: -17.765657,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Santa Cruz de La Palma Port',
    },
    phone: null,
  },
  santaCruzDeTenerife: {
    id: 'santa-cruz-de-tenerife',
    type: OrderPointType.FERRY,
    name: 'Santa Cruz de Tenerife',
    address: {
      label: '38001 Santa Cruz de Tenerife, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '38001',
      city: 'Santa Cruz de Tenerife',
      countryCode: 'es',
      coordinates: {
        latitude: 28.479120360511946,
        longitude: -16.23574517214208,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Santa Cruz de Tenerife (Playa Blanca)',
    },
    phone: null,
  },

  /* Channel Islands */
  guernsey: {
    id: 'guernsey',
    type: OrderPointType.FERRY,
    name: 'Guernsey',
    address: {
      label: 'GY1 2LL Saint Peter Port, GG',
      street: 'New Jetty',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'GY1 2LL',
      city: 'Saint Peter Port',
      countryCode: 'gg',
      coordinates: {
        latitude: 49.457286792216564,
        longitude: -2.529022905249068,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Guernsey Port',
    },
    phone: null,
  },
  jersey: {
    id: 'jersey',
    type: OrderPointType.FERRY,
    name: 'Jersey',
    address: {
      label: 'JE2 3NW St Helier, JE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'JE2 3NW',
      city: 'St Helier',
      countryCode: 'je',
      coordinates: {
        latitude: 49.17934584990713,
        longitude: -2.115726827687624,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Jersey Port',
    },
    phone: null,
  },

  /* Corsica */
  ajaccio: {
    id: 'ajaccio',
    type: OrderPointType.FERRY,
    name: 'Ajaccio',
    address: {
      label: "Quai l'Herminier, 20000 Ajaccio, FR",
      street: "Quai l'Herminier",
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '20000',
      city: 'Ajaccio',
      countryCode: 'fr',
      coordinates: {
        latitude: 41.9216223,
        longitude: 8.739987700000002,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Agence Corsica Ferries',
    },
    phone: {
      areaCode: '+33',
      number: '495507882',
    },
  },
  bastia: {
    id: 'bastia',
    type: OrderPointType.FERRY,
    name: 'Bastia',
    address: {
      label: '20200 Bastia, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '20200',
      city: 'Bastia',
      countryCode: 'fr',
      coordinates: {
        latitude: 42.70222411108439,
        longitude: 9.453004867048067,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Bastia',
    },
    phone: null,
  },
  ileRousse: {
    id: 'ile-rousse',
    type: OrderPointType.FERRY,
    name: 'Ile Rousse',
    address: {
      label: '20220 Ile Rousse, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '20200',
      city: 'Ile Rousse',
      countryCode: 'fr',
      coordinates: {
        latitude: 42.64153934509204,
        longitude: 8.936958169824694,
      },
      type: OnyxAddressType.CUSTOM,
      name: "L'Île-Rousse Port",
    },
    phone: null,
  },
  portoVecchio: {
    id: 'porto-vecchio',
    type: OrderPointType.FERRY,
    name: 'Porto Vecchio',
    address: {
      label: '20137 Porto-Vecchio, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '20137',
      city: 'Porto-Vecchio',
      countryCode: 'fr',
      coordinates: {
        latitude: 41.587473383848646,
        longitude: 9.292394505345962,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Porto Vecchio',
    },
    phone: null,
  },
  propriano: {
    id: 'propriano',
    type: OrderPointType.FERRY,
    name: 'Propriano',
    address: {
      label: "Quai l'Herminier, 20110 Propriano, FR",
      street: "Quai l'Herminier",
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '20110',
      city: 'Propriano',
      countryCode: 'fr',
      coordinates: {
        latitude: 41.67703445216906,
        longitude: 8.89768765002388,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Propriano',
    },
    phone: null,
  },

  /* Croatia */
  dubrovnik: {
    id: 'dubrovnik',
    type: OrderPointType.FERRY,
    name: 'Dubrovnik',
    address: {
      label: 'Obala Ivana Pavla II 1, 20000 Dubrovnik, HR',
      street: 'Obala Ivana Pavla II',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '20000',
      city: 'Dubrovnik',
      countryCode: 'hr',
      coordinates: {
        latitude: 42.65871768454522,
        longitude: 18.085863010899917,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Dubrovnik Port',
    },
    phone: null,
  },
  zadar: {
    id: 'zadar',
    type: OrderPointType.FERRY,
    name: 'Zadar',
    address: {
      label: 'Liburnska obala 4, 23000 Zadar, HR',
      street: 'Liburnska obala',
      houseNumber: '4',
      apartmentNumber: null,
      zipCode: '23000',
      city: 'Zadar',
      countryCode: 'hr',
      coordinates: {
        latitude: 44.11687953110974,
        longitude: 15.2272733033848,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Zadar',
    },
    phone: null,
  },

  /* Cyprus */
  limassol: {
    id: 'limassol',
    type: OrderPointType.FERRY,
    name: 'Limassol',
    address: {
      label: '3045 Limassol, CY',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '3045',
      city: 'Limassol',
      countryCode: 'cy',
      coordinates: {
        latitude: 34.65120710028899,
        longitude: 33.01638976647368,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Limassol',
    },
    phone: null,
  },

  /* Denmark */
  copenhagen: {
    id: 'copenhagen',
    type: OrderPointType.FERRY,
    name: 'Copenhagen',
    address: {
      label: 'Dampfærgevej 30, 2100 København, DK',
      street: 'Dampfærgevej',
      houseNumber: '30',
      apartmentNumber: null,
      zipCode: '2100',
      city: 'København',
      countryCode: 'dk',
      coordinates: {
        latitude: 55.70127160000001,
        longitude: 12.5959731,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Copenhagen',
    },
    phone: {
      areaCode: '+45',
      number: '33423342',
    },
  },
  esbjerg: {
    id: 'esbjerg',
    type: OrderPointType.FERRY,
    name: 'Esbjerg',
    address: {
      label: 'Zodiakvej 5, 6700 Esbjerg, DK',
      street: 'Zodiakvej',
      houseNumber: '5',
      apartmentNumber: null,
      zipCode: '6700',
      city: 'Esbjerg',
      countryCode: 'dk',
      coordinates: {
        latitude: 55.4542194873785,
        longitude: 8.488048693438948,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Zodiakvej 5',
    },
    phone: null,
  },
  fredericia: {
    id: 'fredericia',
    type: OrderPointType.FERRY,
    name: 'Fredericia',
    address: {
      label: 'Vesthavnsvej, 7000 Fredericia, DK',
      street: 'Vesthavnsvej',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '7000',
      city: 'Fredericia',
      countryCode: 'dk',
      coordinates: {
        latitude: 55.560153984609194,
        longitude: 9.743645719972166,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Vesthavnsvej',
    },
    phone: null,
  },
  frederikshavn: {
    id: 'frederikshavn',
    type: OrderPointType.FERRY,
    name: 'Frederikshavn',
    address: {
      label: 'Færgehavnsvej 31, 9900 Frederikshavn, DK',
      street: 'Færgehavnsvej',
      houseNumber: '31',
      apartmentNumber: null,
      zipCode: '9900',
      city: 'Frederikshavn',
      countryCode: 'dk',
      coordinates: {
        latitude: 57.43514368253085,
        longitude: 10.540246916465577,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Frederikshavn Terminal',
    },
    phone: null,
  },
  fynshav: {
    id: 'fynshav',
    type: OrderPointType.FERRY,
    name: 'Fynshav',
    address: {
      label: 'Færgevej 2A, 6440 Augustenborg, DK',
      street: 'Færgevej',
      houseNumber: '2A',
      apartmentNumber: null,
      zipCode: '6440',
      city: 'Augustenborg',
      countryCode: 'dk',
      coordinates: {
        latitude: 54.994139005129384,
        longitude: 9.984951333620701,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Fynshav Havn (færge)',
    },
    phone: null,
  },
  gedser: {
    id: 'gedser',
    type: OrderPointType.FERRY,
    name: 'Gedser',
    address: {
      label: 'Jernbanevejen 1, 4874 Gedser, DK',
      street: 'Jernbanevejen',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '4874',
      city: 'Gedser',
      countryCode: 'dk',
      coordinates: {
        latitude: 54.57717188615202,
        longitude: 11.92358531129016,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Jernbanevejen 1',
    },
    phone: null,
  },
  grenaa: {
    id: 'grenaa',
    type: OrderPointType.FERRY,
    name: 'Grenaa',
    address: {
      label: 'Færgevej 3, 8500 Grenaa, Denmark',
      street: 'Færgevej',
      houseNumber: '3',
      apartmentNumber: null,
      zipCode: '8500',
      city: 'Grenaa',
      countryCode: 'dk',
      coordinates: {
        latitude: 56.4087615,
        longitude: 10.9261962,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Færgevej 3',
    },
    phone: {
      areaCode: '+45',
      number: '96200290',
    },
  },
  havneby: {
    id: 'havneby',
    type: OrderPointType.FERRY,
    name: 'Havneby',
    address: {
      label: 'Kilebryggen 1, 6792 Havenby, DK',
      street: 'Kilebryggen',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '6792',
      city: 'Havenby',
      countryCode: 'dk',
      coordinates: {
        latitude: 55.08583641782792,
        longitude: 8.569452482698948,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Kilebryggen 1',
    },
    phone: null,
  },
  helsingor: {
    id: 'helsingor',
    type: OrderPointType.FERRY,
    name: 'Helsingor',
    address: {
      label: 'Færgevej 8, 3000 Helsingor, DK',
      street: 'Færgevej',
      houseNumber: '8',
      apartmentNumber: null,
      zipCode: '3000',
      city: 'Helsingor',
      countryCode: 'dk',
      coordinates: {
        latitude: 56.02976482061782,
        longitude: 12.609908102807823,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Øresundslinjen',
    },
    phone: null,
  },
  hirtshals: {
    id: 'hirtshals',
    type: OrderPointType.FERRY,
    name: 'Hirtshals',
    address: {
      label: 'Norgeskajen 2, 9850 Hirtshals, DK',
      street: 'Norgeskajen',
      houseNumber: '2',
      apartmentNumber: null,
      zipCode: '9850',
      city: 'Hirtshals',
      countryCode: 'dk',
      coordinates: {
        latitude: 57.59289572379555,
        longitude: 9.968702160150281,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Hirtshals Port',
    },
    phone: null,
  },
  koge: {
    id: 'koge',
    type: OrderPointType.FERRY,
    name: 'Koge',
    address: {
      label: 'Baltic Kaj 1, 4600 Køge, DK',
      street: 'Baltic Kaj',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '4600',
      city: 'Køge',
      countryCode: 'dk',
      coordinates: {
        latitude: 55.455844269205905,
        longitude: 12.194238109350898,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Færgen',
    },
    phone: null,
  },
  rodby: {
    id: 'rodby',
    type: OrderPointType.FERRY,
    name: 'Rodby',
    address: {
      label: '4970 Rødby, DK',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '4970',
      city: 'Rødby',
      countryCode: 'dk',
      coordinates: {
        latitude: 54.65473007078396,
        longitude: 11.351472250969175,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Rodby',
    },
    phone: null,
  },
  ronne: {
    id: 'ronne',
    type: OrderPointType.FERRY,
    name: 'Rønne',
    address: {
      label: 'Finlandsvej 8, 3700 Rønne, DK',
      street: 'Finlandsvej',
      houseNumber: '8',
      apartmentNumber: null,
      zipCode: '3700',
      city: 'Rønne',
      countryCode: 'dk',
      coordinates: {
        latitude: 55.09900891510286,
        longitude: 14.6900491900452,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Rønne Havn (færge)',
    },
    phone: null,
  },
  torshavn: {
    id: 'torshavn',
    type: OrderPointType.FERRY,
    name: 'Tórshavn',
    address: {
      label: 'Havnargøta 1, 100 Tórshavn, DK',
      street: 'Havnargøta',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '100',
      city: 'Tórshavn',
      countryCode: 'dk',
      coordinates: {
        latitude: 62.007238036790454,
        longitude: -6.76447254727151,
      },
      type: OnyxAddressType.CUSTOM,
      name: '1 Havnargøta',
    },
    phone: null,
  },

  /* England */
  dover: {
    id: 'dover',
    type: OrderPointType.FERRY,
    name: 'Dover',
    address: {
      label: 'CT16 1JA Dover, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'CT16 1JA',
      city: 'Dover',
      countryCode: 'gb',
      coordinates: {
        latitude: 51.125061768599245,
        longitude: 1.3337954972913102,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Dover',
    },
    phone: null,
  },
  felixstowe: {
    id: 'felixstowe',
    type: OrderPointType.FERRY,
    name: 'Felixstowe',
    address: {
      label: 'Central Road South, IP11 3SD Felixstowe, GB',
      street: 'Central Road South',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'IP11 3SD',
      city: 'Felixstowe',
      countryCode: 'gb',
      coordinates: {
        latitude: 51.95470659374814,
        longitude: 1.3147087074130615,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Dooley Terminal (Trailer terminal)',
    },
    phone: null,
  },
  folkestone: {
    id: 'folkestone',
    type: OrderPointType.FERRY,
    name: 'Folkestone',
    address: {
      label: 'CT20 1QH Folkestone, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'CT20 1QH',
      city: 'Folkestone',
      countryCode: 'gb',
      coordinates: {
        latitude: 51.07834799744926,
        longitude: 1.1870387989364193,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Folkestone Harbour',
    },
    phone: {
      areaCode: '+44',
      number: '1303254597',
    },
  },
  harwich: {
    id: 'harwich',
    type: OrderPointType.FERRY,
    name: 'Harwich',
    address: {
      label: 'CO12 4SR Harwich, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'CO12 4SR',
      city: 'Harwich',
      countryCode: 'gb',
      coordinates: {
        latitude: 51.94780863180397,
        longitude: 1.2539211428518917,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Harwich',
    },
    phone: {
      areaCode: '+44',
      number: '1255242000',
    },
  },
  heysham: {
    id: 'heysham',
    type: OrderPointType.FERRY,
    name: 'Heysham',
    address: {
      label: 'South Quay, LA3 2XE Heysham, GB',
      street: 'South Quay',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'LA3 2XE',
      city: 'Heysham',
      countryCode: 'gb',
      coordinates: {
        latitude: 54.03371781468877,
        longitude: -2.9123854322925946,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Heysham',
    },
    phone: {
      areaCode: '+44',
      number: '8722992992',
    },
  },
  hull: {
    id: 'hull',
    type: OrderPointType.FERRY,
    name: 'Hull',
    address: {
      label: 'HU9 5PS Hull, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HU9 5PS',
      city: 'Hull',
      countryCode: 'gb',
      coordinates: {
        latitude: 53.74085090947021,
        longitude: -0.28126541213923806,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Hull Ferry Terminal',
    },
    phone: null,
  },
  immingham: {
    id: 'immingham',
    type: OrderPointType.FERRY,
    name: 'Immingham',
    address: {
      label: 'DN40 2NT Immingham, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'DN40 2NT',
      city: 'Immingham',
      countryCode: 'gb',
      coordinates: {
        latitude: 53.638228132849086,
        longitude: -0.20053054812810395,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Immingham',
    },
    phone: {
      areaCode: '+44',
      number: '1469575231',
    },
  },
  killingholme: {
    id: 'killingholme',
    type: OrderPointType.FERRY,
    name: 'Killingholme',
    address: {
      label: 'Clough Lane, DN40 3JP North Killingholme, GB',
      street: 'Clough Lane',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'DN40 3JP',
      city: 'North Killingholme',
      countryCode: 'gb',
      coordinates: {
        latitude: 53.66218681016136,
        longitude: -0.24317545773389676,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'C.Ro Ports Killingholme Ltd',
    },
    phone: {
      areaCode: '+44',
      number: '1469540381',
    },
  },
  liverpool: {
    id: 'liverpool',
    type: OrderPointType.FERRY,
    name: 'Liverpool',
    address: {
      label: 'L20 1BG Bootle, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'L20 1BG',
      city: 'Bootle',
      countryCode: 'gb',
      coordinates: {
        latitude: 53.45871665151903,
        longitude: -3.015469571451834,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'P & O European Ferries (Irish Sea) Ltd',
    },
    phone: {
      areaCode: '+44',
      number: '8706000868',
    },
  },
  liverpoolBirkenhead: {
    id: 'liverpool-birkenhead',
    type: OrderPointType.FERRY,
    name: 'Liverpool Birkenhead',
    address: {
      label: 'Tower Road, CH41 1FE Birkenhead, GB',
      street: 'Tower Road',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'CH41 1FE',
      city: 'Birkenhead',
      countryCode: 'gb',
      coordinates: {
        latitude: 53.40249170943123,
        longitude: -3.0179865967412467,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Birkenhead Ferry Terminal',
    },
    phone: null,
  },
  lymington: {
    id: 'lymington',
    type: OrderPointType.FERRY,
    name: 'Lymington',
    address: {
      label: 'Undershore Road, SO41 5SB Lymington, GB',
      street: 'Undershore Road',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'SO41 5SB',
      city: 'Lymington',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.75732298678083,
        longitude: -1.5289804934891824,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Lymington Pier',
    },
    phone: null,
  },
  newcastle: {
    id: 'newcastle',
    type: OrderPointType.FERRY,
    name: 'Newcastle',
    address: {
      label: 'NE29 6EA North Shields, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'NE29 6EA',
      city: 'North Shields',
      countryCode: 'gb',
      coordinates: {
        latitude: 54.99286724162476,
        longitude: -1.4489240815385862,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'North Shields Port',
    },
    phone: null,
  },
  newhaven: {
    id: 'newhaven',
    type: OrderPointType.FERRY,
    name: 'Newhaven',
    address: {
      label: 'Railway Approach, BN9 0DF Newhaven, GB',
      street: 'Railway Approach',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'BN9 0DF',
      city: 'Newhaven',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.79464722870343,
        longitude: 0.05353197400225094,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Newhaven Terminal',
    },
    phone: null,
  },
  plymouth: {
    id: 'plymouth',
    type: OrderPointType.FERRY,
    name: 'Plymouth',
    address: {
      label: 'PL1 3EW Plymouth, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PL1 3EW',
      city: 'Plymouth',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.36471503621651,
        longitude: -4.1585288813676895,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Plymouth Port',
    },
    phone: null,
  },
  poole: {
    id: 'poole',
    type: OrderPointType.FERRY,
    name: 'Poole',
    address: {
      label: 'New Harbour Road South, BH15 4AJ Poole, GB',
      street: 'New Harbour Road South',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'BH15 4AJ',
      city: 'Poole',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.709230726473145,
        longitude: -1.993204136032138,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Poole',
    },
    phone: null,
  },
  portsmouth: {
    id: 'portsmouth',
    type: OrderPointType.FERRY,
    name: 'Portsmouth',
    address: {
      label: 'Gunwharf Road, PO1 2LA Portsmouth, GB',
      street: 'Gunwharf Road',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PO1 2LA',
      city: 'Portsmouth',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.79289285466772,
        longitude: -1.1065684025934435,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Gunwharf Terminal',
    },
    phone: null,
  },
  purfleet: {
    id: 'purfleet',
    type: OrderPointType.FERRY,
    name: 'Purfleet',
    address: {
      label: 'London Road, RM19 1PD Purfleet, GB',
      street: 'London Road',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'RM19 1PD',
      city: 'Purfleet',
      countryCode: 'gb',
      coordinates: {
        latitude: 51.478462264243774,
        longitude: 0.25358344384549986,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'CLdN Ports London',
    },
    phone: {
      areaCode: '+44',
      number: '1708865522',
    },
  },
  ramsgate: {
    id: 'ramsgate',
    type: OrderPointType.FERRY,
    name: 'Ramsgate',
    address: {
      label: 'Chorley Road 61, PR5 4JN Walton-le-Dale, GB',
      street: 'Chorley Road',
      houseNumber: '61',
      apartmentNumber: null,
      zipCode: 'PR5 4JN',
      city: 'Walton-le-Dale',
      countryCode: 'gb',
      coordinates: {
        latitude: 53.74552101882503,
        longitude: -2.672870790015234,
      },
      type: OnyxAddressType.CUSTOM,
      name: '61 Chorley Rd',
    },
    phone: null,
  },
  sheerness: {
    id: 'sheerness',
    type: OrderPointType.FERRY,
    name: 'Sheerness',
    address: {
      label: 'ME12 1RS Sheerness, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'ME12 1RS',
      city: 'Sheerness',
      countryCode: 'gb',
      coordinates: {
        latitude: 51.44725292747286,
        longitude: 0.745548974303271,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Finnlines | Sheerness',
    },
    phone: {
      areaCode: '+44',
      number: '1482377655',
    },
  },
  southampton: {
    id: 'southampton',
    type: OrderPointType.FERRY,
    name: 'Southampton',
    address: {
      label: 'Town Quay, SO14 2AL Southampton, GB',
      street: 'Town Quay',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'SO14 2AL',
      city: 'Southampton',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.897138884161706,
        longitude: -1.4066771390319965,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Red Funnel Ferries - Vehicle Ferry from Southampton',
    },
    phone: {
      areaCode: '+44',
      number: '2380019192',
    },
  },
  teesport: {
    id: 'teesport',
    type: OrderPointType.FERRY,
    name: 'Teesport',
    address: {
      label: 'TS6 6UD Middlesbrough, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'TS6 6UD',
      city: 'Middlesbrough',
      countryCode: 'gb',
      coordinates: {
        latitude: 54.59740087803322,
        longitude: -1.1492724562491716,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'P&O Ferry Terminal Park',
    },
    phone: null,
  },
  tilbury: {
    id: 'tilbury',
    type: OrderPointType.FERRY,
    name: 'Tilbury',
    address: {
      label: 'RM18 7NJ Tilbury, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'RM18 7NJ',
      city: 'Tilbury',
      countryCode: 'gb',
      coordinates: {
        latitude: 51.45062866633472,
        longitude: 0.3661742891571551,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Tilbury Terminal',
    },
    phone: null,
  },

  /* Estonia */
  muuga: {
    id: 'muuga',
    type: OrderPointType.FERRY,
    name: 'Muuga',
    address: {
      label: '74115 Muuga, EE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '74115',
      city: 'Muuga',
      countryCode: 'ee',
      coordinates: {
        latitude: 59.49001784055951,
        longitude: 24.965517636679003,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Muuga',
    },
    phone: null,
  },
  tallinn: {
    id: 'tallinn',
    type: OrderPointType.FERRY,
    name: 'Tallinn',
    address: {
      label: '10111 Tallinn, EE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '10111',
      city: 'Tallinn',
      countryCode: 'ee',
      coordinates: {
        latitude: 59.444691417854926,
        longitude: 24.769951773081257,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Tallinn',
    },
    phone: null,
  },

  /* Finland */
  hanko: {
    id: 'hanko',
    type: OrderPointType.FERRY,
    name: 'Hanko',
    address: {
      label: '10900 Hanko, FI',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '10900',
      city: 'Hanko',
      countryCode: 'fi',
      coordinates: {
        latitude: 59.81977955577594,
        longitude: 22.945872776752505,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Länsisatama Hanko',
    },
    phone: null,
  },
  helsinki: {
    id: 'helsinki',
    type: OrderPointType.FERRY,
    name: 'Helsinki',
    address: {
      label: 'Tyynenmerenkatu 8, 00220 Helsinki, FI',
      street: 'Tyynenmerenkatu',
      houseNumber: '8',
      apartmentNumber: null,
      zipCode: '00220',
      city: 'Helsinki',
      countryCode: 'fi',
      coordinates: {
        latitude: 60.154381502892534,
        longitude: 24.921062673457335,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'West Terminal 1',
    },
    phone: null,
  },
  helsinkiVuosaari: {
    id: 'helsinki-vuosaari',
    type: OrderPointType.FERRY,
    name: 'Helsinki Vuosaari',
    address: {
      label: 'Provianttikatu 5, 00980 Helsinki, FI',
      street: 'Provianttikatu',
      houseNumber: '5',
      apartmentNumber: null,
      zipCode: '00980',
      city: 'Helsinki',
      countryCode: 'fi',
      coordinates: {
        latitude: 60.222783253125854,
        longitude: 25.175124182454944,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Finnlines Vuosaari',
    },
    phone: null,
  },
  langnas: {
    id: 'langnas',
    type: OrderPointType.FERRY,
    name: 'Långnäs',
    address: {
      label: '22630 Lumparland, FI',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '22630',
      city: 'Lumparland',
      countryCode: 'fi',
      coordinates: {
        latitude: 60.117056785391355,
        longitude: 20.299998964989726,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Åland',
    },
    phone: null,
  },
  mariehamn: {
    id: 'mariehamn',
    type: OrderPointType.FERRY,
    name: 'Mariehamn',
    address: {
      label: 'Hamngatan 24, 22100 Mariehamn, FI',
      street: 'Hamngatan',
      houseNumber: '24',
      apartmentNumber: null,
      zipCode: '22100',
      city: 'Mariehamn',
      countryCode: 'fi',
      coordinates: {
        latitude: 60.0920491417865,
        longitude: 19.928962072180042,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Mariehamn',
    },
    phone: {
      areaCode: '+358',
      number: '185310',
    },
  },
  naantali: {
    id: 'naantali',
    type: OrderPointType.FERRY,
    name: 'Naantali',
    address: {
      label: 'Satamatie 13, 21100 Naantali, FI',
      street: 'Satamatie',
      houseNumber: '13',
      apartmentNumber: null,
      zipCode: '21100',
      city: 'Naantali',
      countryCode: 'fi',
      coordinates: {
        latitude: 60.45781522411765,
        longitude: 22.043727557044676,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Naantali Port',
    },
    phone: {
      areaCode: '+358',
      number: '447334550',
    },
  },
  turku: {
    id: 'turku',
    type: OrderPointType.FERRY,
    name: 'Turku',
    address: {
      label: 'Ensimmäinen linja 6, 20100 Turku, FI',
      street: 'Ensimmäinen linja',
      houseNumber: '6',
      apartmentNumber: null,
      zipCode: '20100',
      city: 'Turku',
      countryCode: 'fi',
      coordinates: {
        latitude: 60.43349895061507,
        longitude: 22.221899819998335,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Turku',
    },
    phone: null,
  },
  vaasa: {
    id: 'vaasa',
    type: OrderPointType.FERRY,
    name: 'Vaasa',
    address: {
      label: 'Vanha Satamatie, 65170 Vaasa, FI',
      street: 'Vanha Satamatie',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '65170',
      city: 'Vaasa',
      countryCode: 'fi',
      coordinates: {
        latitude: 63.08763793823064,
        longitude: 21.55694235137457,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Vaasa',
    },
    phone: {
      areaCode: '+358',
      number: '207716810',
    },
  },

  /* France */
  caen: {
    id: 'caen',
    type: OrderPointType.FERRY,
    name: 'Caen',
    address: {
      label: 'Avenue du Grand Large, 14150 Ouistreham, FR',
      street: 'Avenue du Grand Large',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '14150',
      city: 'Ouistreham',
      countryCode: 'fr',
      coordinates: {
        latitude: 49.28483503911675,
        longitude: -0.24909152223182723,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caen Port',
    },
    phone: null,
  },
  calais: {
    id: 'calais',
    type: OrderPointType.FERRY,
    name: 'Calais',
    address: {
      label: '62100 Calais, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '62100',
      city: 'Calais',
      countryCode: 'fr',
      coordinates: {
        latitude: 50.96673781900345,
        longitude: 1.8496943685992469,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Calais',
    },
    phone: null,
  },
  cherbourg: {
    id: 'cherbourg',
    type: OrderPointType.FERRY,
    name: 'Cherbourg',
    address: {
      label: 'Quai de Normandie, 50100 Cherbourg-en-Cotentin, FR',
      street: 'Quai de Normandie',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '50100',
      city: 'Cherbourg-en-Cotentin',
      countryCode: 'fr',
      coordinates: {
        latitude: 49.64589572460928,
        longitude: -1.611572239783736,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Cherbourg',
    },
    phone: null,
  },
  dieppe: {
    id: 'dieppe',
    type: OrderPointType.FERRY,
    name: 'Dieppe',
    address: {
      label: 'Quai Gaston Lalitte 7, 76200 Dieppe, FR',
      street: 'Quai Gaston Lalitte',
      houseNumber: '7',
      apartmentNumber: null,
      zipCode: '76200',
      city: 'Dieppe',
      countryCode: 'fr',
      coordinates: {
        latitude: 49.93367776198122,
        longitude: 1.0881041974376786,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Dieppe',
    },
    phone: null,
  },
  dunkirk: {
    id: 'dunkirk',
    type: OrderPointType.FERRY,
    name: 'Dunkirk',
    address: {
      label: 'Route de la Maison Blanche, 59279 Loon-Plage, FR',
      street: 'Route de la Maison Blanche',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '59279',
      city: 'Loon-Plage',
      countryCode: 'fr',
      coordinates: {
        latitude: 51.02020769535783,
        longitude: 2.1897193003147373,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Dunkirk Terminal',
    },
    phone: null,
  },
  leHavre: {
    id: 'le-havre',
    type: OrderPointType.FERRY,
    name: 'Le Havre',
    address: {
      label: '76600 Le Havre, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '76600',
      city: 'Le Havre',
      countryCode: 'fr',
      coordinates: {
        latitude: 49.485056276496984,
        longitude: 0.11660724569946555,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Le Havre',
    },
    phone: {
      areaCode: '+33',
      number: '235511020',
    },
  },
  marseille: {
    id: 'marseille',
    type: OrderPointType.FERRY,
    name: 'Marseille',
    address: {
      label: 'Chemin du Littoral 13015, 13015 Marseille, FR',
      street: 'Chemin du Littoral',
      houseNumber: '13015',
      apartmentNumber: null,
      zipCode: '13015',
      city: 'Marseille',
      countryCode: 'fr',
      coordinates: {
        latitude: 43.340402099435885,
        longitude: 5.347218719509226,
      },
      type: OnyxAddressType.CUSTOM,
      name: '13015 Chem. du Littoral',
    },
    phone: null,
  },
  nice: {
    id: 'nice',
    type: OrderPointType.FERRY,
    name: 'Nice',
    address: {
      label: '06300 Nice, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '06300',
      city: 'Nice',
      countryCode: 'fr',
      coordinates: {
        latitude: 43.69379119295673,
        longitude: 7.288829194326516,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Nice',
    },
    phone: null,
  },
  roscoff: {
    id: 'roscoff',
    type: OrderPointType.FERRY,
    name: 'Roscoff',
    address: {
      label: 'Port du Bloscon, 29680 Roscoff, FR',
      street: 'Port du Bloscon',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '29680',
      city: 'Roscoff',
      countryCode: 'fr',
      coordinates: {
        latitude: 48.721265723592154,
        longitude: -3.9629050651280155,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Roscoff',
    },
    phone: {
      areaCode: '+33',
      number: '298292813',
    },
  },
  sete: {
    id: 'sete',
    type: OrderPointType.FERRY,
    name: 'Sète',
    address: {
      label: '34200 Sète, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '34200',
      city: 'Sète',
      countryCode: 'fr',
      coordinates: {
        latitude: 43.404623509204804,
        longitude: 3.704015007735779,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Sète Port',
    },
    phone: null,
  },
  stMalo: {
    id: 'st-malo',
    type: OrderPointType.FERRY,
    name: 'St Malo',
    address: {
      label: 'Terre-Plein du Naye, 35400 Saint-Malo, FR',
      street: 'Terre-Plein du Naye',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '35400',
      city: 'Saint-Malo',
      countryCode: 'fr',
      coordinates: {
        latitude: 48.64198998990289,
        longitude: -2.0235043621255624,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'St Malo',
    },
    phone: null,
  },
  toulon: {
    id: 'toulon',
    type: OrderPointType.FERRY,
    name: 'Toulon',
    address: {
      label: '83000 Toulon, FR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '83000',
      city: 'Toulon',
      countryCode: 'fr',
      coordinates: {
        latitude: 43.11634956275659,
        longitude: 5.933678593469154,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Toulon',
    },
    phone: null,
  },

  /* Georgia */
  batumi: {
    id: 'batumi',
    type: OrderPointType.FERRY,
    name: 'Batumi',
    address: {
      label: 'Gogebashvili Street 3, 6010 Batumi, GE',
      street: 'Gogebashvili Street',
      houseNumber: '3',
      apartmentNumber: null,
      zipCode: '6010',
      city: 'Batumi',
      countryCode: 'ge',
      coordinates: {
        latitude: 41.65212976432128,
        longitude: 41.64373822180852,
      },
      type: OnyxAddressType.CUSTOM,
      name: '3 Gogebashvili St',
    },
    phone: null,
  },
  poti: {
    id: 'poti',
    type: OrderPointType.FERRY,
    name: 'Poti',
    address: {
      label: '4400 Poti, GE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '4400',
      city: 'Poti',
      countryCode: 'ge',
      coordinates: {
        latitude: 42.15252177949573,
        longitude: 41.65208730079402,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Poti Seaport',
    },
    phone: null,
  },

  /* Germany */
  cuxhaven: {
    id: 'cuxhaven',
    type: OrderPointType.FERRY,
    name: 'Cuxhaven',
    address: {
      label: 'Neufelder Schanze, 27472 Cuxhaven, DE',
      street: 'Neufelder Schanze',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '27472',
      city: 'Cuxhaven',
      countryCode: 'de',
      coordinates: {
        latitude: 53.86296773812696,
        longitude: 8.723023156290774,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Cuxhaven-Immingham Ferry-Terminal England-Fracht-Fähre',
    },
    phone: {
      areaCode: '+49',
      number: '472179600',
    },
  },
  kiel: {
    id: 'kiel',
    type: OrderPointType.FERRY,
    name: 'Kiel',
    address: {
      label: 'Ostuferhafen 15, 24149 Kiel, DE',
      street: 'Ostuferhafen',
      houseNumber: '15',
      apartmentNumber: null,
      zipCode: '24149',
      city: 'Kiel',
      countryCode: 'de',
      coordinates: {
        latitude: 54.33391449797006,
        longitude: 10.176965064341521,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Kiel Terminal',
    },
    phone: {
      areaCode: '+49',
      number: '403890371',
    },
  },
  list: {
    id: 'list',
    type: OrderPointType.FERRY,
    name: 'List',
    address: {
      label: 'Am Fähranleger, 25992 List, DE',
      street: 'Am Fähranleger',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '25992',
      city: 'List',
      countryCode: 'de',
      coordinates: {
        latitude: 55.015777924982615,
        longitude: 8.439798093163141,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Hafen von List',
    },
    phone: null,
  },
  puttgarden: {
    id: 'puttgarden',
    type: OrderPointType.FERRY,
    name: 'Puttgarden',
    address: {
      label: '23769 Fehmarn, DE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '23769',
      city: 'Fehmarn',
      countryCode: 'de',
      coordinates: {
        latitude: 54.50282259999999,
        longitude: 11.2286385,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Puttgarden(MS)',
    },
    phone: null,
  },
  rostock: {
    id: 'rostock',
    type: OrderPointType.FERRY,
    name: 'Rostock',
    address: {
      label: '18147 Rostock, DE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '18147',
      city: 'Rostock',
      countryCode: 'de',
      coordinates: {
        latitude: 54.15111946822216,
        longitude: 12.1010304553769,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Rostock Port',
    },
    phone: null,
  },
  sassnitz: {
    id: 'sassnitz',
    type: OrderPointType.FERRY,
    name: 'Sassnitz',
    address: {
      label: 'Im Fährhafen 20, 18546 Sassnitz, DE',
      street: 'Im Fährhafen',
      houseNumber: '20',
      apartmentNumber: null,
      zipCode: '18546',
      city: 'Sassnitz',
      countryCode: 'de',
      coordinates: {
        latitude: 54.48421067975049,
        longitude: 13.587507568466082,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Sassnitz Mukran Port',
    },
    phone: null,
  },
  travemunde: {
    id: 'travemunde',
    type: OrderPointType.FERRY,
    name: 'Travemunde',
    address: {
      label: '23570 Travemünde, DE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '23570',
      city: 'Travemünde',
      countryCode: 'de',
      coordinates: {
        latitude: 53.94800493296584,
        longitude: 10.858423032280976,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Travemunde',
    },
    phone: null,
  },

  /* Greece */
  igoumenitsa: {
    id: 'igoumenitsa',
    type: OrderPointType.FERRY,
    name: 'Igoumenitsa',
    address: {
      label: '461 00 Igoumenitsa, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '461 00',
      city: 'Igoumenitsa',
      countryCode: 'gr',
      coordinates: {
        latitude: 39.487575146204904,
        longitude: 20.256736193193877,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Igoumenitsa Port',
    },
    phone: {
      areaCode: '+30',
      number: '2665361800',
    },
  },
  lavrio: {
    id: 'lavrio',
    type: OrderPointType.FERRY,
    name: 'Lavrio',
    address: {
      label: '195 00 Lavrio, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '195 00',
      city: 'Lavrio',
      countryCode: 'gr',
      coordinates: {
        latitude: 37.71225123759974,
        longitude: 24.063242972408815,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Lavrio',
    },
    phone: {
      areaCode: '+30',
      number: '2292061009',
    },
  },
  patras: {
    id: 'patras',
    type: OrderPointType.FERRY,
    name: 'Patras',
    address: {
      label: 'Akti Dimeon 25, 263 33 Patra, GR',
      street: 'Akti Dimeon',
      houseNumber: '25',
      apartmentNumber: null,
      zipCode: '263 33',
      city: 'Patra',
      countryCode: 'gr',
      coordinates: {
        latitude: 38.227188545044086,
        longitude: 21.71906923091516,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Patras New Port',
    },
    phone: {
      areaCode: '+30',
      number: '2610365135',
    },
  },
  piraeus: {
    id: 'piraeus',
    type: OrderPointType.FERRY,
    name: 'Piraeus',
    address: {
      label: '185 31 Piraeus, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '185 31',
      city: 'Piraeus',
      countryCode: 'gr',
      coordinates: {
        latitude: 37.94475159566847,
        longitude: 23.638372383394653,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Piraeus',
    },
    phone: {
      areaCode: '+30',
      number: '2104060900',
    },
  },
  rhodes: {
    id: 'rhodes',
    type: OrderPointType.FERRY,
    name: 'Rhodes',
    address: {
      label: '851 00 Rhodes, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '851 00',
      city: 'Rhodes',
      countryCode: 'gr',
      coordinates: {
        latitude: 36.44677951155971,
        longitude: 28.23255444954648,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Rhodes Port',
    },
    phone: {
      areaCode: '+30',
      number: '2241078510',
    },
  },
  thessaloniki: {
    id: 'thessaloniki',
    type: OrderPointType.FERRY,
    name: 'Thessaloniki',
    address: {
      label: 'Averof, 546 26 Thessaloniki, GR',
      street: 'Averof',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '546 26',
      city: 'Thessaloniki',
      countryCode: 'gr',
      coordinates: {
        latitude: 40.63547712111254,
        longitude: 22.932941808605104,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Thessaloniki Ferry Port',
    },
    phone: {
      areaCode: '+30',
      number: '2310593118',
    },
  },

  /* Greek Islands */
  chania: {
    id: 'chania',
    type: OrderPointType.FERRY,
    name: 'Chania',
    address: {
      label: '731 34 Souda, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '731 34',
      city: 'Souda',
      countryCode: 'gr',
      coordinates: {
        latitude: 35.489002531932435,
        longitude: 24.075593780085022,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Souda',
    },
    phone: {
      areaCode: '+30',
      number: '2821089240',
    },
  },
  corfu: {
    id: 'corfu',
    type: OrderPointType.FERRY,
    name: 'Corfu',
    address: {
      label: '491 00 Corfu, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '491 00',
      city: 'Corfu',
      countryCode: 'gr',
      coordinates: {
        latitude: 39.6274734032148,
        longitude: 19.904011963555558,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Corfu',
    },
    phone: {
      areaCode: '+30',
      number: '2661045551',
    },
  },
  heraklion: {
    id: 'heraklion',
    type: OrderPointType.FERRY,
    name: 'Heraklion',
    address: {
      label: '713 07 Heraklion, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '713 07',
      city: 'Heraklion',
      countryCode: 'gr',
      coordinates: {
        latitude: 35.34341354155104,
        longitude: 25.142554836096963,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Heraklion',
    },
    phone: null,
  },
  kos: {
    id: 'kos',
    type: OrderPointType.FERRY,
    name: 'Kos',
    address: {
      label: '853 00 Kos, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '853 00',
      city: 'Kos',
      countryCode: 'gr',
      coordinates: {
        latitude: 36.89849224650435,
        longitude: 27.29035235388102,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Kos',
    },
    phone: {
      areaCode: '+30',
      number: '2242026594',
    },
  },
  mykonos: {
    id: 'mykonos',
    type: OrderPointType.FERRY,
    name: 'Mykonos',
    address: {
      label: '846 00 Tourlos, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '846 00',
      city: 'Tourlos',
      countryCode: 'gr',
      coordinates: {
        latitude: 37.463480070922174,
        longitude: 25.325341851231112,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Mykonos',
    },
    phone: {
      areaCode: '+30',
      number: '2289028934',
    },
  },
  naxos: {
    id: 'naxos',
    type: OrderPointType.FERRY,
    name: 'Naxos',
    address: {
      label: '843 00 Naxos, GR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '843 00',
      city: 'Naxos',
      countryCode: 'gr',
      coordinates: {
        latitude: 37.10621899376733,
        longitude: 25.37143856579047,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Naxos Port',
    },
    phone: null,
  },

  /* Iceland */
  seydisfjordur: {
    id: 'seydisfjordur',
    type: OrderPointType.FERRY,
    name: 'Seyðisfjörður',
    address: {
      label: 'Fjarðargata 8, 710 Seyðisfjörður, IS',
      street: 'Fjarðargata',
      houseNumber: '8',
      apartmentNumber: null,
      zipCode: '710',
      city: 'Seyðisfjörður',
      countryCode: 'is',
      coordinates: {
        latitude: 65.26419526844317,
        longitude: -14.007138456309347,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Seyðisfjörður Port, IJsland',
    },
    phone: null,
  },
  thorlakshofn: {
    id: 'thorlakshofn',
    type: OrderPointType.FERRY,
    name: 'Thorlakshofn',
    address: {
      label: 'Óseyrarbraut, 815 Thorlakshofn, IS',
      street: 'Óseyrarbraut',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '815',
      city: 'Thorlakshofn',
      countryCode: 'is',
      coordinates: {
        latitude: 63.858446821996175,
        longitude: -21.373730724525554,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Herjólfur',
    },
    phone: null,
  },

  /* Isle of Man */
  douglas: {
    id: 'douglas',
    type: OrderPointType.FERRY,
    name: 'Douglas',
    address: {
      label: 'IM1 2RF Douglas, IM',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'IM1 2RF',
      city: 'Douglas',
      countryCode: 'im',
      coordinates: {
        latitude: 54.14715273595626,
        longitude: -4.467616600128377,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Douglas',
    },
    phone: {
      areaCode: '+44',
      number: '1624661661',
    },
  },

  /* Isle of Wight */
  eastCowes: {
    id: 'east-cowes',
    type: OrderPointType.FERRY,
    name: 'East Cowes',
    address: {
      label: 'PO32 6RF East Cowes, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PO32 6RF',
      city: 'East Cowes',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.75886716304991,
        longitude: -1.2900470786246452,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'East Cowes Terminal',
    },
    phone: null,
  },
  fishbourne: {
    id: 'fishbourne',
    type: OrderPointType.FERRY,
    name: 'Fishbourne',
    address: {
      label: 'Fishbourne Lane, PO33 4EU Isle of Wight, GB',
      street: 'Fishbourne Lane',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PO33 4EU',
      city: 'Isle of Wight',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.73438869251189,
        longitude: -1.213469006934871,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Fishbourne IOW Terminal',
    },
    phone: null,
  },
  yarmouth: {
    id: 'yarmouth',
    type: OrderPointType.FERRY,
    name: 'Yarmouth',
    address: {
      label: 'Quay Street, PO41 0PB Yarmouth, GB',
      street: 'Quay Street',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PO41 0PB',
      city: 'Yarmouth',
      countryCode: 'gb',
      coordinates: {
        latitude: 50.70657780740378,
        longitude: -1.5006205870229867,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Fishbourne IOW Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '3339997333',
    },
  },

  /* Italy */
  ancona: {
    id: 'ancona',
    type: OrderPointType.FERRY,
    name: 'Ancona',
    address: {
      label: 'Molo Santa Maria, 60121 Ancona, IT',
      street: 'Molo Santa Maria',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '60121',
      city: 'Ancona',
      countryCode: 'it',
      coordinates: {
        latitude: 43.62082570224993,
        longitude: 13.507419246962906,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Ancona (Molo Santa Maria)',
    },
    phone: {
      areaCode: '+39',
      number: '071207891',
    },
  },
  bari: {
    id: 'bari',
    type: OrderPointType.FERRY,
    name: 'Bari',
    address: {
      label: '70123 Bari, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '70123',
      city: 'Bari',
      countryCode: 'it',
      coordinates: {
        latitude: 41.13269284051538,
        longitude: 16.866871896332626,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Bari Port',
    },
    phone: null,
  },
  brindisi: {
    id: 'brindisi',
    type: OrderPointType.FERRY,
    name: 'Brindisi',
    address: {
      label: '72100 Pedagne, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '72100',
      city: 'Pedagne',
      countryCode: 'it',
      coordinates: {
        latitude: 40.64569241662277,
        longitude: 17.958416528861086,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Brindisi (Costa Morena Punta Delle Terrare)',
    },
    phone: null,
  },
  civitavecchia: {
    id: 'civitavecchia',
    type: OrderPointType.FERRY,
    name: 'Civitavecchia',
    address: {
      label: '00053 Civitavecchia, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '00053',
      city: 'Civitavecchia',
      countryCode: 'it',
      coordinates: {
        latitude: 42.09793757960611,
        longitude: 11.780763116398262,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Civitavecchia',
    },
    phone: {
      areaCode: '+39',
      number: '076621621',
    },
  },
  genoa: {
    id: 'genoa',
    type: OrderPointType.FERRY,
    name: 'Genoa',
    address: {
      label: 'Piazzale dei Traghetti Iqbal Masih, 16126 Genoa, IT',
      street: 'Piazzale dei Traghetti Iqbal Masih',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '16126',
      city: 'Genoa',
      countryCode: 'it',
      coordinates: {
        latitude: 44.41064001779897,
        longitude: 8.9085625291026,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Genoa Port',
    },
    phone: {
      areaCode: '+39',
      number: '0102094599',
    },
  },
  livorno: {
    id: 'livorno',
    type: OrderPointType.FERRY,
    name: 'Livorno',
    address: {
      label: '57123 Livorno, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '57123',
      city: 'Livorno',
      countryCode: 'it',
      coordinates: {
        latitude: 43.55333558400057,
        longitude: 10.300574020384845,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Livorno',
    },
    phone: null,
  },
  marinaDiCarrara: {
    id: 'marina-di-carrara',
    type: OrderPointType.FERRY,
    name: 'Marina di Carrara',
    address: {
      label: 'Viale Giovanni da Verrazzano, 54033 Marina di Carrara, IT',
      street: 'Viale Giovanni da Verrazzano',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '54033',
      city: 'Marina di Carrara',
      countryCode: 'it',
      coordinates: {
        latitude: 44.03309185064186,
        longitude: 10.040075303584874,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Porto di Carrara',
    },
    phone: null,
  },
  messina: {
    id: 'messina',
    type: OrderPointType.FERRY,
    name: 'Messina',
    address: {
      label: 'Via Calabria, 98122 Messina, IT',
      street: 'Via Calabria',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '98122',
      city: 'Messina',
      countryCode: 'it',
      coordinates: {
        latitude: 38.18911739007662,
        longitude: 15.563034567456226,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Messina Port',
    },
    phone: null,
  },
  naples: {
    id: 'naples',
    type: OrderPointType.FERRY,
    name: 'Naples',
    address: {
      label: 'Calata Porta di Massa, 80133 Napoli, IT',
      street: 'Calata Porta di Massa',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '80133',
      city: 'Napoli',
      countryCode: 'it',
      coordinates: {
        latitude: 40.84339193329808,
        longitude: 14.261016335515338,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Calata Porta di Massa',
    },
    phone: {
      areaCode: '+39',
      number: '0815800016',
    },
  },
  piombino: {
    id: 'piombino',
    type: OrderPointType.FERRY,
    name: 'Piombino',
    address: {
      label: 'Piazzale Premuda, 57025 Piombino, IT',
      street: 'Piazzale Premuda',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '57025',
      city: 'Piombino',
      countryCode: 'it',
      coordinates: {
        latitude: 42.92971648962092,
        longitude: 10.546549544996084,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Piombino',
    },
    phone: {
      areaCode: '+39',
      number: '0565229210',
    },
  },
  portoTorres: {
    id: 'porto-torres',
    type: OrderPointType.FERRY,
    name: 'Porto Torres',
    address: {
      label: 'Via Amerigo Vespucci, 07046 Porto Torres, IT',
      street: 'Via Amerigo Vespucci',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '07046',
      city: 'Porto Torres',
      countryCode: 'it',
      coordinates: {
        latitude: 40.84159855726727,
        longitude: 8.377889128158248,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Porto Torres (Molo Asi)',
    },
    phone: {
      areaCode: '+39',
      number: '079523688',
    },
  },
  portoferraio: {
    id: 'portoferraio',
    type: OrderPointType.FERRY,
    name: 'Portoferraio',
    address: {
      label: 'Calata Italia, 57037 Portoferraio, IT',
      street: 'Calata Italia',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '57037',
      city: 'Portoferraio',
      countryCode: 'it',
      coordinates: {
        latitude: 42.81201363814607,
        longitude: 10.32451927086849,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Portoferraio',
    },
    phone: null,
  },
  ravenna: {
    id: 'ravenna',
    type: OrderPointType.FERRY,
    name: 'Ravenna',
    address: {
      label: 'Via Baiona 151, 48123 Ravenna, IT',
      street: 'Via Baiona',
      houseNumber: '151',
      apartmentNumber: null,
      zipCode: '48123',
      city: 'Ravenna',
      countryCode: 'it',
      coordinates: {
        latitude: 44.47167138133245,
        longitude: 12.248101472270461,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Porto di Ravenna - Area industriale',
    },
    phone: null,
  },
  salerno: {
    id: 'salerno',
    type: OrderPointType.FERRY,
    name: 'salerno',
    address: {
      label: '84121 Salerno, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '84121',
      city: 'Salerno',
      countryCode: 'it',
      coordinates: {
        latitude: 40.67453520871513,
        longitude: 14.751854703441952,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Salerno',
    },
    phone: null,
  },
  savona: {
    id: 'savona',
    type: OrderPointType.FERRY,
    name: 'Savona',
    address: {
      label: '17100 Savona, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '17100',
      city: 'Savona',
      countryCode: 'it',
      coordinates: {
        latitude: 44.31213804787671,
        longitude: 8.492377400931053,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Savona',
    },
    phone: null,
  },
  trieste: {
    id: 'trieste',
    type: OrderPointType.FERRY,
    name: 'Trieste',
    address: {
      label: 'Via del Lazzaretto Vecchio 3, 34123 Trieste, IT',
      street: 'Via del Lazzaretto Vecchio',
      houseNumber: '3',
      apartmentNumber: null,
      zipCode: '34123',
      city: 'Trieste',
      countryCode: 'it',
      coordinates: {
        latitude: 45.646464552349784,
        longitude: 13.761939217605232,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Via del Lazzaretto Vecchio, 3',
    },
    phone: null,
  },
  venice: {
    id: 'venice',
    type: OrderPointType.FERRY,
    name: 'Venice',
    address: {
      label: 'Venetian Lagoon, 30176 Venice, IT',
      street: 'Venetian Lagoon',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '30176',
      city: 'Venice',
      countryCode: 'it',
      coordinates: {
        latitude: 45.425467398183784,
        longitude: 12.256999153558473,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Ferry Terminal',
    },
    phone: null,
  },
  villaSanGiovanni: {
    id: 'villa-san-giovanni',
    type: OrderPointType.FERRY,
    name: 'Villa San Giovanni',
    address: {
      label: 'Via Stazione Imbarco Automezzi, 89018 Villa San Giovanni, IT',
      street: 'Via Stazione Imbarco Automezzi',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '89018',
      city: 'Villa San Giovanni',
      countryCode: 'it',
      coordinates: {
        latitude: 38.21525191431989,
        longitude: 15.635010965418413,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Bluferries Ticket - Villa San Giovanni',
    },
    phone: {
      areaCode: '+39',
      number: '0965791309',
    },
  },

  /* Latvia */
  liepaja: {
    id: 'liepaja',
    type: OrderPointType.FERRY,
    name: 'Liepaja',
    address: {
      label: 'Brīvostas iela 14A, 3405 Liepāja, LV',
      street: 'Brīvostas iela',
      houseNumber: '14A',
      apartmentNumber: null,
      zipCode: '3405',
      city: 'Liepāja',
      countryCode: 'lv',
      coordinates: {
        latitude: 56.52925889230931,
        longitude: 20.99853371518096,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'LSEZ Terrabalt SIA',
    },
    phone: {
      areaCode: '+371',
      number: '63425756',
    },
  },
  ventspils: {
    id: 'ventspils',
    type: OrderPointType.FERRY,
    name: 'Ventspils',
    address: {
      label: 'Dzintaru iela 90D, 3602 Ventspils, LV',
      street: 'Dzintaru iela',
      houseNumber: '90D',
      apartmentNumber: null,
      zipCode: '3602',
      city: 'Ventspils',
      countryCode: 'lv',
      coordinates: {
        latitude: 57.39780779262837,
        longitude: 21.545261518112962,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Ventspils',
    },
    phone: null,
  },

  /* Lithuania */
  klaipeda: {
    id: 'klaipeda',
    type: OrderPointType.FERRY,
    name: 'Klaipeda',
    address: {
      label: '93277 Klaipeda, LT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '93277',
      city: 'Klaipeda',
      countryCode: 'lt',
      coordinates: {
        latitude: 55.68339428141966,
        longitude: 21.139978618968257,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Klaipeda Port',
    },
    phone: {
      areaCode: '+370',
      number: '46313137',
    },
  },

  /* Morocco */
  // TODO

  /* Netherlands */
  hookOfHolland: {
    id: 'hook-of-holland',
    type: OrderPointType.FERRY,
    name: 'Hook of Holland',
    address: {
      label: 'Stationsweg 10, 3151 HS Hoek van Holland, NL',
      street: 'Stationsweg',
      houseNumber: '10',
      apartmentNumber: null,
      zipCode: '3151 HS',
      city: 'Hoek van Holland',
      countryCode: 'nl',
      coordinates: {
        latitude: 51.96639984845099,
        longitude: 4.148428542644893,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Stena Line (Freight) - Hoek van Holland',
    },
    phone: {
      areaCode: '+31',
      number: '174315811',
    },
  },
  ijmuiden: {
    id: 'ijmuiden',
    type: OrderPointType.FERRY,
    name: 'Ijmuiden',
    address: {
      label: 'Sluisplein 33, 1975 AG Ijmuiden, NL',
      street: 'Sluisplein',
      houseNumber: '33',
      apartmentNumber: null,
      zipCode: '1975 AG',
      city: 'Ijmuiden',
      countryCode: 'nl',
      coordinates: {
        latitude: 52.46260866163804,
        longitude: 4.584541053334752,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Amsterdam Terminal',
    },
    phone: {
      areaCode: '+31',
      number: '255546666',
    },
  },
  rotterdamEuropoortMerseyweg: {
    id: 'rotterdam-europoort-merseyweg',
    type: OrderPointType.FERRY,
    name: 'Rotterdam (Europoort & Merseyweg)',
    address: {
      label: 'Luxemburgweg 2, 3198 LG Europoort Rotterdam, NL',
      street: 'Luxemburgweg',
      houseNumber: '2',
      apartmentNumber: null,
      zipCode: '3198 LG',
      city: 'Europoort Rotterdam',
      countryCode: 'nl',
      coordinates: {
        latitude: 51.94497788355469,
        longitude: 4.130944313432436,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Rotterdam',
    },
    phone: null,
  },
  rotterdamVlaardingen: {
    id: 'rotterdam-vlaardingen',
    type: OrderPointType.FERRY,
    name: 'Rotterdam Vlaardingen',
    address: {
      label: 'Vulcaanweg 20, 3134 KL Vlaardingen, NL',
      street: 'Vulcaanweg',
      houseNumber: '20',
      apartmentNumber: null,
      zipCode: '3134 KL',
      city: 'Vlaardingen',
      countryCode: 'nl',
      coordinates: {
        latitude: 51.9051995887852,
        longitude: 4.358948268484085,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Vlaardingen - Freight Office & Ferry Terminal',
    },
    phone: {
      areaCode: '+31',
      number: '102084000',
    },
  },

  /* Northern Ireland */
  belfast: {
    id: 'belfast',
    type: OrderPointType.FERRY,
    name: 'Belfast',
    address: {
      label: 'West Bank Road 4, BT3 9JL Belfast, GB',
      street: 'West Bank Road',
      houseNumber: '4',
      apartmentNumber: null,
      zipCode: 'BT3 9JL',
      city: 'Vlaardingen',
      countryCode: 'gb',
      coordinates: {
        latitude: 54.63577663420556,
        longitude: -5.8816452358521305,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Victoria Terminal 4',
    },
    phone: null,
  },
  larne: {
    id: 'larne',
    type: OrderPointType.FERRY,
    name: 'Larne',
    address: {
      label: 'BT40 1AW Larne, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'BT40 1AW',
      city: 'Larne',
      countryCode: 'gb',
      coordinates: {
        latitude: 54.849238825535245,
        longitude: -5.7960616389476325,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Larne',
    },
    phone: null,
  },
  warrenpoint: {
    id: 'warrenpoint',
    type: OrderPointType.FERRY,
    name: 'Warrenpoint',
    address: {
      label: 'Queen Street 35, BT34 3HN Warrenpoint, GB',
      street: 'Queen Street',
      houseNumber: '35',
      apartmentNumber: null,
      zipCode: 'BT34 3HN',
      city: 'Warrenpoint',
      countryCode: 'gb',
      coordinates: {
        latitude: 54.09891273340743,
        longitude: -6.249537180334797,
      },
      type: OnyxAddressType.CUSTOM,
      name: '35 Queen St',
    },
    phone: null,
  },

  /* Norway */
  brevik: {
    id: 'brevik',
    type: OrderPointType.FERRY,
    name: 'Brevik',
    address: {
      label: 'Tangenvegen 40, 3950 Brevik, NO',
      street: 'Tangenvegen',
      houseNumber: '40',
      apartmentNumber: null,
      zipCode: '3950',
      city: 'Brevik',
      countryCode: 'no',
      coordinates: {
        latitude: 59.0662597277941,
        longitude: 9.699154867824275,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'North Sea Terminal',
    },
    phone: null,
  },
  frederikstad: {
    id: 'frederikstad',
    type: OrderPointType.FERRY,
    name: 'Frederikstad',
    address: {
      label: 'Øraveien 16, 1630 Gamle Fredrikstad, NO',
      street: 'Øraveien',
      houseNumber: '16',
      apartmentNumber: null,
      zipCode: '3950',
      city: 'Gamle Fredrikstad',
      countryCode: 'no',
      coordinates: {
        latitude: 59.18540576645869,
        longitude: 10.956624065412566,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Andersen & Mørck AS',
    },
    phone: {
      areaCode: '+47',
      number: '69358500',
    },
  },
  haugesund: {
    id: 'haugesund',
    type: OrderPointType.FERRY,
    name: 'Haugesund',
    address: {
      label: 'Garpeskjærvegen 1E, 5527 Haugesund, NO',
      street: 'Garpeskjærvegen',
      houseNumber: '1E',
      apartmentNumber: null,
      zipCode: '5527',
      city: 'Haugesund',
      countryCode: 'no',
      coordinates: {
        latitude: 59.41212877707082,
        longitude: 5.255708743587141,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Garpaskjær ferjekai',
    },
    phone: null,
  },
  kristiansand: {
    id: 'kristiansand',
    type: OrderPointType.FERRY,
    name: 'Kristiansand',
    address: {
      label: 'Vesterveien 21, 4613 Kristiansand, NO',
      street: 'Vesterveien',
      houseNumber: '21',
      apartmentNumber: null,
      zipCode: '4613',
      city: 'Kristiansand',
      countryCode: 'no',
      coordinates: {
        latitude: 58.14412587085243,
        longitude: 7.9851987509527875,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Kristiansand',
    },
    phone: {
      areaCode: '+47',
      number: '38006000',
    },
  },
  langesund: {
    id: 'langesund',
    type: OrderPointType.FERRY,
    name: 'Langesund',
    address: {
      label: '3970 Langesund, NO',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '3970',
      city: 'Langesund',
      countryCode: 'no',
      coordinates: {
        latitude: 59.00647726266281,
        longitude: 9.746847105031334,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Langesund Port',
    },
    phone: null,
  },
  larvik: {
    id: 'larvik',
    type: OrderPointType.FERRY,
    name: 'Larvik',
    address: {
      label: 'Revet 8, 3263 Larvik, NO',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '3263',
      city: 'Larvik',
      countryCode: 'no',
      coordinates: {
        latitude: 59.0408990057535,
        longitude: 10.044929187588835,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Larvik',
    },
    phone: null,
  },
  oslo: {
    id: 'oslo',
    type: OrderPointType.FERRY,
    name: 'Oslo',
    address: {
      label: '0150 Oslo, NO',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '0150',
      city: 'Oslo',
      countryCode: 'no',
      coordinates: {
        latitude: 59.90224911697668,
        longitude: 10.740755751288724,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Oslo Port',
    },
    phone: null,
  },
  sandefjord: {
    id: 'sandefjord',
    type: OrderPointType.FERRY,
    name: 'Sandefjord',
    address: {
      label: 'Strandpromenaden 20, 3210 Sandefjord, NO',
      street: 'Strandpromenaden',
      houseNumber: '20',
      apartmentNumber: null,
      zipCode: '3210',
      city: 'Sandefjord',
      countryCode: 'no',
      coordinates: {
        latitude: 59.12578592966778,
        longitude: 10.22479456704157,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Sandefjord',
    },
    phone: {
      areaCode: '+47',
      number: '22944200',
    },
  },
  tananger: {
    id: 'tananger',
    type: OrderPointType.FERRY,
    name: 'Tananger',
    address: {
      label: '4056 Tananger, NO',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '4056',
      city: 'Tananger',
      countryCode: 'no',
      coordinates: {
        latitude: 58.92103251560223,
        longitude: 5.58273756382639,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Stavanger Port',
    },
    phone: null,
  },

  /* Poland */
  gdansk: {
    id: 'gdansk',
    type: OrderPointType.FERRY,
    name: 'Gdańsk',
    address: {
      label: 'mjr. Henryka Sucharskiego 70, 80-601 Gdańsk, PL',
      street: 'mjr. Henryka Sucharskiego',
      houseNumber: '70',
      apartmentNumber: null,
      zipCode: '80-601',
      city: 'Gdańsk',
      countryCode: 'pl',
      coordinates: {
        latitude: 54.40366879459047,
        longitude: 18.68132083684912,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Polferries Terminal Promowy Gdańsk',
    },
    phone: {
      areaCode: '+48',
      number: '222302222',
    },
  },
  gdynia: {
    id: 'gdynia',
    type: OrderPointType.FERRY,
    name: 'Gdynia',
    address: {
      label: 'Polska 4, 81-339 Gdynia, PL',
      street: 'Polska',
      houseNumber: '4',
      apartmentNumber: null,
      zipCode: '81-339',
      city: 'Gdynia',
      countryCode: 'pl',
      coordinates: {
        latitude: 54.53360111412615,
        longitude: 18.545881084712427,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Gdynia',
    },
    phone: {
      areaCode: '+48',
      number: '586609200',
    },
  },
  swinoujscie: {
    id: 'swinoujscie',
    type: OrderPointType.FERRY,
    name: 'Świnoujście',
    address: {
      label: 'Dworcowa 1, 72-606 Świnoujście, PL',
      street: 'Dworcowa',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '72-606',
      city: 'Świnoujście',
      countryCode: 'pl',
      coordinates: {
        latitude: 53.90094660644199,
        longitude: 14.259156239886845,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Swinoujscie Ferry Terminal Sp. o.o.',
    },
    phone: {
      areaCode: '+48',
      number: '913226101',
    },
  },

  /* Republic of Ireland */
  cork: {
    id: 'cork',
    type: OrderPointType.FERRY,
    name: 'Cork',
    address: {
      label: 'T23 YNT9 Cork, IE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'T23 YNT9',
      city: 'Cork',
      countryCode: 'ie',
      coordinates: {
        latitude: 51.90037673112825,
        longitude: -8.416052706048493,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Cork',
    },
    phone: {
      areaCode: '+353',
      number: '214273125',
    },
  },
  dublin: {
    id: 'dublin',
    type: OrderPointType.FERRY,
    name: 'Dublin',
    address: {
      label: 'Alexandra Road, D01 WD28 Dublin, IE',
      street: 'Alexandra Road',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'D01 WD28',
      city: 'Dublin',
      countryCode: 'ie',
      coordinates: {
        latitude: 53.345029908868035,
        longitude: -6.196139862511553,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Dublin (Terminal 1)',
    },
    phone: {
      areaCode: '+353',
      number: '19075555',
    },
  },
  rosslare: {
    id: 'rosslare',
    type: OrderPointType.FERRY,
    name: 'Rosslare',
    address: {
      label: 'Y35 PH4X Rosslare Harbour, IE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'Y35 PH4X',
      city: 'Rosslare Harbour',
      countryCode: 'ie',
      coordinates: {
        latitude: 52.25499890243575,
        longitude: -6.338000651352189,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Rosslare Terminal',
    },
    phone: {
      areaCode: '+353',
      number: '19075555',
    },
  },

  /* Romania */
  constanta: {
    id: 'constanta',
    type: OrderPointType.FERRY,
    name: 'Constanta',
    address: {
      label: '900900 Constanța, RO',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '900900',
      city: 'Constanta',
      countryCode: 'ro',
      coordinates: {
        latitude: 44.13209879435134,
        longitude: 28.645258362562892,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Constanța',
    },
    phone: {
      areaCode: '+40',
      number: '241611540',
    },
  },

  /* Russia */
  stPetersburg: {
    id: 'st-petersburg',
    type: OrderPointType.FERRY,
    name: 'St Petersburg',
    address: {
      label: '199106 St Petersburg, RU',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '199106',
      city: 'St Petersburg',
      countryCode: 'ru',
      coordinates: {
        latitude: 59.92952698017988,
        longitude: 30.231799720744732,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'St Petersburg',
    },
    phone: null,
  },
  ustLuga: {
    id: 'ust-luga',
    type: OrderPointType.FERRY,
    name: 'Ust Luga',
    address: {
      label: '188472 Ust-Luga, RU',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '188472',
      city: 'Ust-Luga',
      countryCode: 'ru',
      coordinates: {
        latitude: 59.68209860497934,
        longitude: 28.437626412971373,
      },
      type: OnyxAddressType.CUSTOM,
      name: "Port Ust'-Luga",
    },
    phone: null,
  },

  /* Sardinia */
  arbatax: {
    id: 'arbatax',
    type: OrderPointType.FERRY,
    name: 'Arbatax',
    address: {
      label: '08048 Arbatax, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '08048',
      city: 'Arbatax',
      countryCode: 'it',
      coordinates: {
        latitude: 39.93942321871595,
        longitude: 9.708169970786741,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Arbatax Port',
    },
    phone: null,
  },
  cagliari: {
    id: 'cagliari',
    type: OrderPointType.FERRY,
    name: 'Cagliari',
    address: {
      label: '09125 Cagliari, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '09125',
      city: 'Cagliari',
      countryCode: 'it',
      coordinates: {
        latitude: 39.21122360045736,
        longitude: 9.106700332419974,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Cagliari',
    },
    phone: null,
  },
  golfoAranci: {
    id: 'golfo-aranci',
    type: OrderPointType.FERRY,
    name: 'Golfo Aranci',
    address: {
      label: 'Viale Stazione 8, 07020 Golfo Aranci, IT',
      street: 'Viale Stazione',
      houseNumber: '8',
      apartmentNumber: null,
      zipCode: '07020',
      city: 'Golfo Aranci',
      countryCode: 'it',
      coordinates: {
        latitude: 40.99468478047066,
        longitude: 9.621555549267654,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Golfo Aranci',
    },
    phone: null,
  },
  olbia: {
    id: 'olbia',
    type: OrderPointType.FERRY,
    name: 'Olbia',
    address: {
      label: 'Banchina Isola Bianca, 07026 Olbia, IT',
      street: 'Banchina Isola Bianca',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '07026',
      city: 'Olbia',
      countryCode: 'it',
      coordinates: {
        latitude: 40.922806430489864,
        longitude: 9.52422607260194,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Olbia',
    },
    phone: null,
  },

  /* Scotland */
  aberdeen: {
    id: 'aberdeen',
    type: OrderPointType.FERRY,
    name: 'Aberdeen',
    address: {
      label: "Jamieson's Quay, AB11 5NP Aberdeen, GB",
      street: "Jamieson's Quay",
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'AB11 5NP',
      city: 'Aberdeen',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.145071884562775,
        longitude: -2.091445164513463,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Aberdeen Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8001114422',
    },
  },
  ardrossan: {
    id: 'ardrossan',
    type: OrderPointType.FERRY,
    name: 'Ardrossan',
    address: {
      label: 'KA22 8BZ Ardrossan, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'KA22 8BZ',
      city: 'Ardrossan',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.6405265684599,
        longitude: -4.822930047006439,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Ardrossan',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  cairnryan: {
    id: 'cairnryan',
    type: OrderPointType.FERRY,
    name: 'Cairnryan',
    address: {
      label: 'A77, DG9 8RF Stranraer, GB',
      street: 'A77',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'DG9 8RF',
      city: 'Stranraer',
      countryCode: 'gb',
      coordinates: {
        latitude: 54.965661252628465,
        longitude: -5.014959309166688,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'P&O Ferries Cairnryan',
    },
    phone: {
      areaCode: '+44',
      number: '1304448888',
    },
  },
  campbeltown: {
    id: 'campbeltown',
    type: OrderPointType.FERRY,
    name: 'Campbeltown',
    address: {
      label: 'PA28 6BE Campbeltown, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA28 6BE',
      city: 'Campbeltown',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.424028858525254,
        longitude: -5.599394146886723,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Campbeltown Ferry Terminal',
    },
    phone: null,
  },
  claonaig: {
    id: 'claonaig',
    type: OrderPointType.FERRY,
    name: 'Claonaig',
    address: {
      label: 'PA29 6YG Tarbert, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA29 6YG',
      city: 'Tarbert',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.751067219770334,
        longitude: -5.38784490506065,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Claonaig',
    },
    phone: null,
  },
  colintraive: {
    id: 'colintraive',
    type: OrderPointType.FERRY,
    name: 'Colintraive',
    address: {
      label: 'PA22 3AP Colintraive, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA22 3AP',
      city: 'Colintraive',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.923345865523714,
        longitude: -5.152732755589912,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Colintraive Ferry Terminal',
    },
    phone: null,
  },
  kennacraig: {
    id: 'kennacraig',
    type: OrderPointType.FERRY,
    name: 'Kennacraig',
    address: {
      label: 'PA29 6YF Tarbert, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA29 6YF',
      city: 'Tarbert',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.806516365706344,
        longitude: -5.48245044364253,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Kennacraig',
    },
    phone: {
      areaCode: '+44',
      number: '1880730253',
    },
  },
  kilchoan: {
    id: 'kilchoan',
    type: OrderPointType.FERRY,
    name: 'Kilchoan',
    address: {
      label: 'PA36 4LH Kilchoan, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA36 4LH',
      city: 'Kilchoan',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.68855190539797,
        longitude: -6.093950660572251,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Kilchoan Ferry Terminal',
    },
    phone: null,
  },
  largs: {
    id: 'largs',
    type: OrderPointType.FERRY,
    name: 'Largs',
    address: {
      label: 'KA30 8BG Largs, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'KA30 8BG',
      city: 'Largs',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.79493996649704,
        longitude: -4.8709934997554445,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Largs Ferry Terminal',
    },
    phone: null,
  },
  lochaline: {
    id: 'lochaline',
    type: OrderPointType.FERRY,
    name: 'Lochaline',
    address: {
      label: 'PA80 5XP Morvern, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA80 5XP',
      city: 'Morvern',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.53635141467506,
        longitude: -5.775893802577128,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Lochaline Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '1475650397',
    },
  },
  mallaig: {
    id: 'mallaig',
    type: OrderPointType.FERRY,
    name: 'Mallaig',
    address: {
      label: 'PH41 4QD Mallaig, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PH41 4QD',
      city: 'Mallaig',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.00681206277184,
        longitude: -5.828052930135886,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Mallaig Ferry Terminal',
    },
    phone: null,
  },
  portavadie: {
    id: 'portavadie',
    type: OrderPointType.FERRY,
    name: 'Portavadie',
    address: {
      label: 'PA21 2DA Tighnabruaich, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA21 2DA',
      city: 'Tighnabruaich',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.87659025590067,
        longitude: -5.316703705760392,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Portavadie',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  scrabster: {
    id: 'scrabster',
    type: OrderPointType.FERRY,
    name: 'Scrabster',
    address: {
      label: 'KW14 7UT Scrabster, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'KW14 7UT',
      city: 'Scrabster',
      countryCode: 'gb',
      coordinates: {
        latitude: 58.61233126137208,
        longitude: -3.5456165242712188,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Scrabster Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8001114422',
    },
  },
  tarbertLochFyne: {
    id: 'tarbert-loch-fyne',
    type: OrderPointType.FERRY,
    name: 'Tarbert (Loch Fyne)',
    address: {
      label: 'PA29 6UF Tarbert, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA29 6UF',
      city: 'Tarbert',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.86615664252775,
        longitude: -5.403737794495761,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Tarbert Ferry Terminal',
    },
    phone: null,
  },
  tayinloan: {
    id: 'tayinloan',
    type: OrderPointType.FERRY,
    name: 'Tayinloan',
    address: {
      label: 'PA29 6XG Tayinloan, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA29 6XG',
      city: 'Tayinloan',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.65756276939195,
        longitude: -5.670400950620167,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'CalMac Ferries Tayinloan',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  ullapool: {
    id: 'ullapool',
    type: OrderPointType.FERRY,
    name: 'Ullapool',
    address: {
      label: 'IV26 2UR Ullapool, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'IV26 2UR',
      city: 'Ullapool',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.894988664386645,
        longitude: -5.15960999392836,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Ullapool Ferry Terminal',
    },
    phone: null,
  },
  wemyssBay: {
    id: 'wemyss-bay',
    type: OrderPointType.FERRY,
    name: 'Wemyss Bay',
    address: {
      label: 'Shore Rd, PA18 6AR Wemyss Bay, GB',
      street: 'Shore Rd',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA18 6AR',
      city: 'Wemyss Bay',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.87573480218941,
        longitude: -4.890789476382004,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Wemyss Bay',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },

  /* Scottish Isles */
  armadale: {
    id: 'armadale',
    type: OrderPointType.FERRY,
    name: 'Armadale',
    address: {
      label: 'IV45 8RS Armadale, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'IV45 8RS',
      city: 'Armadale',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.0645418295477,
        longitude: -5.894899426627817,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Armadale Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  barraArdmhor: {
    id: 'barra-ardmhor',
    type: OrderPointType.FERRY,
    name: 'Barra (Ardmhor)',
    address: {
      label: 'HS9 5YB Ardmhor, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS9 5YB',
      city: 'Ardmhor',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.00857772702589,
        longitude: -7.403289809504311,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Aird Mhor Barra Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  berneray: {
    id: 'berneray',
    type: OrderPointType.FERRY,
    name: 'Berneray',
    address: {
      label: 'HS6 5BJ Isle of North Uist, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS6 5BJ',
      city: 'Isle of North Uist',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.70227002047254,
        longitude: -7.18041054944824,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Berneray Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  brodick: {
    id: 'brodick',
    type: OrderPointType.FERRY,
    name: 'Brodick',
    address: {
      label: 'KA27 8AY Brodick, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'KA27 8AY',
      city: 'Brodick',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.57713186899798,
        longitude: -5.138882602967011,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Brodick',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  canna: {
    id: 'canna',
    type: OrderPointType.FERRY,
    name: 'Canna',
    address: {
      label: 'PH44 4RS Isle of Canna, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PH44 4RS',
      city: 'Isle of Canna',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.05592530066176,
        longitude: -6.490847022013366,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne |Canna',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  castlebay: {
    id: 'castlebay',
    type: OrderPointType.FERRY,
    name: 'Castlebay',
    address: {
      label: 'HS9 5XD Castlebay, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS9 5XD',
      city: 'Castlebay',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.953813828235525,
        longitude: -7.488215866149873,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Castlebay Barra Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '1871200304',
    },
  },
  coll: {
    id: 'coll',
    type: OrderPointType.FERRY,
    name: 'Coll',
    address: {
      label: 'PA78 6SY Isle of Coll, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA78 6SY',
      city: 'Isle of Coll',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.61503916183776,
        longitude: -6.524207253014595,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Coll Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '1879230347',
    },
  },
  craignure: {
    id: 'craignure',
    type: OrderPointType.FERRY,
    name: 'Craignure',
    address: {
      label: 'PA65 6AY Craignure, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA65 6AY',
      city: 'Craignure',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.470739995708314,
        longitude: -5.70628902195732,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Craignure Mull Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '1680340258',
    },
  },
  cumbrae: {
    id: 'cumbrae',
    type: OrderPointType.FERRY,
    name: 'Cumbrae',
    address: {
      label: 'KA28 0HQ Isle of Cumbrae, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'KA28 0HQ',
      city: 'Isle of Cumbrae',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.7866582923369,
        longitude: -4.8981234795040205,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Cumbrae',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  eigg: {
    id: 'eigg',
    type: OrderPointType.FERRY,
    name: 'Eigg',
    address: {
      label: 'PH42 4RL Isle of Eigg, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PH42 4RL',
      city: 'Isle of Eigg',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.879431958166585,
        longitude: -6.127730295293877,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Eigg',
    },
    phone: null,
  },
  eriskay: {
    id: 'eriskay',
    type: OrderPointType.FERRY,
    name: 'Eriskay',
    address: {
      label: 'HS8 5JN Isle of South Uist, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS8 5JN',
      city: 'Isle of South Uist',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.07089910083339,
        longitude: -7.308218695791087,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Eriskay Ferry Terminal',
    },
    phone: null,
  },
  fionnphort: {
    id: 'fionnphort',
    type: OrderPointType.FERRY,
    name: 'Fionnphort',
    address: {
      label: 'PA66 6BL Fionnphort, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA66 6BL',
      city: 'Fionnphort',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.32617624972214,
        longitude: -6.370654731444614,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Fionnphort',
    },
    phone: null,
  },
  fishnish: {
    id: 'fishnish',
    type: OrderPointType.FERRY,
    name: 'Fishnish',
    address: {
      label: 'PA65 6BA Fishnish, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA65 6BA',
      city: 'Fishnish',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.51484882804757,
        longitude: -5.809967530130586,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Fishnish',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  gigha: {
    id: 'gigha',
    type: OrderPointType.FERRY,
    name: 'Gigha',
    address: {
      label: 'PA41 7AB Gigha, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA41 7AB',
      city: 'Gigha',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.67761469422624,
        longitude: -5.733828752175411,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Gigha',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  iona: {
    id: 'iona',
    type: OrderPointType.FERRY,
    name: 'Iona',
    address: {
      label: 'PA76 6SJ Isle of Iona, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA76 6SJ',
      city: 'Isle of Iona',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.33032748966912,
        longitude: -6.3914727056993135,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Iona',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  kirkwall: {
    id: 'kirkwall',
    type: OrderPointType.FERRY,
    name: 'Kirkwall',
    address: {
      label: 'KW15 1RQ Kirkwall, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'KW15 1RQ',
      city: 'Kirkwall',
      countryCode: 'gb',
      coordinates: {
        latitude: 58.999872921212244,
        longitude: -2.974086674072407,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Kirkwall Orkney Hatston',
    },
    phone: {
      areaCode: '+44',
      number: '8001114422',
    },
  },
  lerwick: {
    id: 'lerwick',
    type: OrderPointType.FERRY,
    name: 'Lerwick',
    address: {
      label: 'Holmsgarth ferry terminal, ZE1 0PR Holmsgarth, GB',
      street: 'Holmsgarth ferry terminal',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'ZE1 0PR',
      city: 'Holmsgarth',
      countryCode: 'gb',
      coordinates: {
        latitude: 60.16259300053456,
        longitude: -1.1575742778426774,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Lerwick Shetland Holmsgarth Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8001114422',
    },
  },
  leverburgh: {
    id: 'leverburgh',
    type: OrderPointType.FERRY,
    name: 'Leverburgh',
    address: {
      label: 'HS5 3UB Leverburgh, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS5 3UB',
      city: 'Leverburgh',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.766508925961425,
        longitude: -7.025249860270697,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Leverburgh Harris Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  lismore: {
    id: 'lismore',
    type: OrderPointType.FERRY,
    name: 'Lismore',
    address: {
      label: 'PA34 5UJ Isle of Lismore, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA34 5UJ',
      city: 'Isle of Lismore',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.511729357808065,
        longitude: -5.49207163890009,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Lismore',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  lochboisdale: {
    id: 'lochboisdale',
    type: OrderPointType.FERRY,
    name: 'Lochboisdale',
    address: {
      label: 'HS8 5TH Lochboisdale, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS8 5TH',
      city: 'Lochboisdale',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.152167167653445,
        longitude: -7.30394259280899,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Lochboisdale South Uist Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '1878790218',
    },
  },
  lochmaddy: {
    id: 'lochmaddy',
    type: OrderPointType.FERRY,
    name: 'Lochmaddy',
    address: {
      label: 'HS6 5AA Lochmaddy, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS6 5AA',
      city: 'Lochmaddy',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.5965426668328,
        longitude: -7.156763424025645,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Lochmaddy Ferry Terminal',
    },
    phone: null,
  },
  lochranza: {
    id: 'lochranza',
    type: OrderPointType.FERRY,
    name: 'Lochranza',
    address: {
      label: 'KA27 8HL Lochranza, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'KA27 8HL',
      city: 'Lochranza',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.70770897291681,
        longitude: -5.301953042211003,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Lochranza Arran Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  muck: {
    id: 'muck',
    type: OrderPointType.FERRY,
    name: 'Muck',
    address: {
      label: 'PH41 2RP Isle of Muck, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PH41 2RP',
      city: 'Isle of Muck',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.832127031631195,
        longitude: -6.224443892811546,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Port Mòr',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  oban: {
    id: 'oban',
    type: OrderPointType.FERRY,
    name: 'Oban',
    address: {
      label: 'Alma Crescent, PA34 4LE Oban, GB',
      street: 'Alma Crescent',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA34 4LE',
      city: 'Oban',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.41220254571169,
        longitude: -5.475998393758525,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Oban Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  portAskaig: {
    id: 'port-askaig',
    type: OrderPointType.FERRY,
    name: 'Port Askaig',
    address: {
      label: 'PA46 7RB Port Askaig, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA46 7RB',
      city: 'Port Askaig',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.84840082810404,
        longitude: -6.104851841637097,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Port Askaig',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  portEllen: {
    id: 'port-ellen',
    type: OrderPointType.FERRY,
    name: 'Port Ellen',
    address: {
      label: 'PA42 7DW Glenegedale, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA42 7DW',
      city: 'Glenegedale',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.627696880791056,
        longitude: -6.189742539931202,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port Ellen Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '1496302209',
    },
  },
  raasay: {
    id: 'raasay',
    type: OrderPointType.FERRY,
    name: 'Raasay',
    address: {
      label: 'IV48 8TD Isle of Raasay, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'IV48 8TD',
      city: 'Isle of Raasay',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.3502732073897,
        longitude: -6.082236698043234,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Raasay',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  rhubodach: {
    id: 'rhubodach',
    type: OrderPointType.FERRY,
    name: 'Rhubodach',
    address: {
      label: 'PA20 0QL Rhubodach, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA20 0QL',
      city: 'Rhubodach',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.92066875417381,
        longitude: -5.158676379171988,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Rhubodach',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  rothesay: {
    id: 'rothesay',
    type: OrderPointType.FERRY,
    name: 'Rothesay',
    address: {
      label: 'West Pier, PA20 9AQ Rothesay, GB',
      street: 'West Pier',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA20 9AQ',
      city: 'Rothesay',
      countryCode: 'gb',
      coordinates: {
        latitude: 55.83877872656779,
        longitude: -5.052642876614075,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Caledonian MacBrayne | Rothesay',
    },
    phone: {
      areaCode: '+44',
      number: '1700502707',
    },
  },
  rum: {
    id: 'rum',
    type: OrderPointType.FERRY,
    name: 'Rum',
    address: {
      label: 'PH43 4RR Isle Of Rum, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PH43 4RR',
      city: 'Isle Of Rum',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.010836846179494,
        longitude: -6.2649687678352475,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Rum Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  sconser: {
    id: 'sconser',
    type: OrderPointType.FERRY,
    name: 'Sconser',
    address: {
      label: 'IV48 8TD Sconser, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'IV48 8TD',
      city: 'Sconser',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.313941389457256,
        longitude: -6.110315729952004,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Sconser Isle Of Skye Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  stornoway: {
    id: 'stornoway',
    type: OrderPointType.FERRY,
    name: 'Stornoway',
    address: {
      label: 'Shell Street, HS1 2AE Stornoway, GB',
      street: 'Shell Street',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS1 2AE',
      city: 'Stornoway',
      countryCode: 'gb',
      coordinates: {
        latitude: 58.2061298905635,
        longitude: -6.387208314302682,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Stornoway Lewis Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '1851307470',
    },
  },
  stromness: {
    id: 'stromness',
    type: OrderPointType.FERRY,
    name: 'Stromness',
    address: {
      label: 'Ferry Road, KW16 3BH Stromness, GB',
      street: 'Ferry Road',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'KW16 3BH',
      city: 'Stromness',
      countryCode: 'gb',
      coordinates: {
        latitude: 58.96407681250878,
        longitude: -3.295542285600117,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Stromness',
    },
    phone: {
      areaCode: '+44',
      number: '8001114422',
    },
  },
  tarbertHarris: {
    id: 'tarbert-harris',
    type: OrderPointType.FERRY,
    name: 'Tarbert (Harris)',
    address: {
      label: 'Pier Road, HS3 3DG Tarbert, GB',
      street: 'Pier Road',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'HS3 3DG',
      city: 'Tarbert',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.89695288061101,
        longitude: -6.79877933459316,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Tarbert Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '1859502444',
    },
  },
  tiree: {
    id: 'tiree',
    type: OrderPointType.FERRY,
    name: 'Tiree',
    address: {
      label: 'Pier Road, PA77 6TN Scarinish, GB',
      street: 'Pier Road',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA77 6TN',
      city: 'Scarinish',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.508300109427154,
        longitude: -6.7988867854239015,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Tiree Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '8000665000',
    },
  },
  tobermory: {
    id: 'tobermory',
    type: OrderPointType.FERRY,
    name: 'Tobermory',
    address: {
      label: 'A848, PA75 6PR Tobermory, GB',
      street: 'A848',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'PA75 6PR',
      city: 'Tobermory',
      countryCode: 'gb',
      coordinates: {
        latitude: 56.62330071524992,
        longitude: -6.06333093086723,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Tobermory',
    },
    phone: null,
  },
  uig: {
    id: 'uig',
    type: OrderPointType.FERRY,
    name: 'Uig',
    address: {
      label: 'IV51 9XX Isle of Skye, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'IV51 9XX',
      city: 'Isle of Skye',
      countryCode: 'gb',
      coordinates: {
        latitude: 57.58631405169456,
        longitude: -6.376435129906299,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Uig Skye Ferry Terminal',
    },
    phone: null,
  },

  /* Sicily */
  catania: {
    id: 'catania',
    type: OrderPointType.FERRY,
    name: 'Catania',
    address: {
      label: 'Ingresso Varco Dusmet, 95121 Catania, IT',
      street: 'Ingresso Varco Dusmet',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '95121',
      city: 'Catania',
      countryCode: 'it',
      coordinates: {
        latitude: 37.498962205335005,
        longitude: 15.09550215363113,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Catania',
    },
    phone: null,
  },
  palermo: {
    id: 'palermo',
    type: OrderPointType.FERRY,
    name: 'Palermo',
    address: {
      label: 'Banchina Crispi, 90133 Palermo, IT',
      street: 'Banchina Crispi',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '90133',
      city: 'Palermo',
      countryCode: 'it',
      coordinates: {
        latitude: 38.12814166959879,
        longitude: 13.363410169826572,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Termini Imerese Port',
    },
    phone: null,
  },
  pozzallo: {
    id: 'pozzallo',
    type: OrderPointType.FERRY,
    name: 'Pozzallo',
    address: {
      label: '97016 Zona Portuale, IT',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '97016',
      city: 'Zona Portuale',
      countryCode: 'it',
      coordinates: {
        latitude: 36.71656827572951,
        longitude: 14.830416376031442,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Pozzallo',
    },
    phone: {
      areaCode: '+39',
      number: '0932811811',
    },
  },
  terminiImerese: {
    id: 'termini-imerese',
    type: OrderPointType.FERRY,
    name: 'Termini Imerese',
    address: {
      label: 'Lungomare Cristoforo Colombo, 90018 Termini Imerese, IT',
      street: 'Lungomare Cristoforo Colombo',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '90018',
      city: 'Termini Imerese',
      countryCode: 'it',
      coordinates: {
        latitude: 37.98606828702598,
        longitude: 13.70429632300795,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Palermo Termini Imerese',
    },
    phone: null,
  },
  tremestieri: {
    id: 'tremestieri',
    type: OrderPointType.FERRY,
    name: 'Tremestieri',
    address: {
      label: 'Viale della Libertà 39, 98121 Messina, IT',
      street: 'Viale della Libertà',
      houseNumber: '39',
      apartmentNumber: null,
      zipCode: '98121',
      city: 'Messina',
      countryCode: 'it',
      coordinates: {
        latitude: 38.20967731273273,
        longitude: 15.561262849386926,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Imbarchi Traghetti Caronte & Tourist',
    },
    phone: null,
  },

  /* Spain */
  algeciras: {
    id: 'algeciras',
    type: OrderPointType.FERRY,
    name: 'Algeciras',
    address: {
      label: '11201 Algeciras, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '11201',
      city: 'Algeciras',
      countryCode: 'es',
      coordinates: {
        latitude: 36.13064850519441,
        longitude: -5.437730031857074,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Algeciras',
    },
    phone: null,
  },
  almeria: {
    id: 'almeria',
    type: OrderPointType.FERRY,
    name: 'Almeria',
    address: {
      label: '04002 Almeria, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '04002',
      city: 'Almeria',
      countryCode: 'es',
      coordinates: {
        latitude: 36.83308143946428,
        longitude: -2.4668336438717824,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Almeria',
    },
    phone: {
      areaCode: '+34',
      number: '956798733',
    },
  },
  barcelona: {
    id: 'barcelona',
    type: OrderPointType.FERRY,
    name: 'Barcelona',
    address: {
      label: '08039 Barcelona, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '08039',
      city: 'Barcelona',
      countryCode: 'es',
      coordinates: {
        latitude: 41.37240646773949,
        longitude: 2.18040475581686,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Barcelona - Terminal Nord',
    },
    phone: null,
  },
  bilbao: {
    id: 'bilbao',
    type: OrderPointType.FERRY,
    name: 'Bilbao',
    address: {
      label: '48508 Zierbena, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '48508',
      city: 'Zierbena',
      countryCode: 'es',
      coordinates: {
        latitude: 43.35348157724892,
        longitude: -3.0704727785297554,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Bilbao',
    },
    phone: {
      areaCode: '+34',
      number: '902108147',
    },
  },
  cadiz: {
    id: 'cadiz',
    type: OrderPointType.FERRY,
    name: 'Cadiz',
    address: {
      label: 'Avenida del Puerto 2B, 11006 Cádiz, ES',
      street: 'Avenida del Puerto',
      houseNumber: '2B',
      apartmentNumber: null,
      zipCode: '11006',
      city: 'Cádiz',
      countryCode: 'es',
      coordinates: {
        latitude: 36.53091340820716,
        longitude: -6.289547075952557,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Terminal Marítima Cádiz',
    },
    phone: null,
  },
  ceuta: {
    id: 'ceuta',
    type: OrderPointType.FERRY,
    name: 'Ceuta',
    address: {
      label: '51001 Ceuta, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '51001',
      city: 'Ceuta',
      countryCode: 'es',
      coordinates: {
        latitude: 35.894775714404496,
        longitude: -5.321320187970897,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Ceuta',
    },
    phone: null,
  },
  denia: {
    id: 'denia',
    type: OrderPointType.FERRY,
    name: 'Denia',
    address: {
      label: '03700 Denia, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '03700',
      city: 'Denia',
      countryCode: 'es',
      coordinates: {
        latitude: 38.844310311067254,
        longitude: 0.1140498959572551,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Denia',
    },
    phone: {
      areaCode: '+34',
      number: '912660215',
    },
  },
  huelva: {
    id: 'huelva',
    type: OrderPointType.FERRY,
    name: 'Huelva',
    address: {
      label: '21810 Palos de la Frontera, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '21810',
      city: 'Palos de la Frontera',
      countryCode: 'es',
      coordinates: {
        latitude: 37.14834530366916,
        longitude: -6.874007972707607,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Huelva Port',
    },
    phone: {
      areaCode: '+34',
      number: '865608423',
    },
  },
  malaga: {
    id: 'malaga',
    type: OrderPointType.FERRY,
    name: 'Malaga',
    address: {
      label: '29001 Malaga, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '29001',
      city: 'Malaga',
      countryCode: 'es',
      coordinates: {
        latitude: 36.71586091542267,
        longitude: -4.419237077481953,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Malaga Port',
    },
    phone: {
      areaCode: '+34',
      number: '912660215',
    },
  },
  motril: {
    id: 'motril',
    type: OrderPointType.FERRY,
    name: 'Motril',
    address: {
      label: '18613 Motril, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '18613',
      city: 'Motril',
      countryCode: 'es',
      coordinates: {
        latitude: 36.724664402623134,
        longitude: -3.527833920708206,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Motril Port',
    },
    phone: null,
  },
  puertoDeGandia: {
    id: 'puerto-de-gandia',
    type: OrderPointType.FERRY,
    name: 'Puerto de Gandia',
    address: {
      label: '46730 Gandia, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '46730',
      city: 'Gandia',
      countryCode: 'es',
      coordinates: {
        latitude: 38.994891219713374,
        longitude: -0.15141676987224142,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Gandia Ferry Terminal',
    },
    phone: null,
  },
  sagunto: {
    id: 'sagunto',
    type: OrderPointType.FERRY,
    name: 'Sagunto',
    address: {
      label: '46520 Valencia, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '46520',
      city: 'Valencia',
      countryCode: 'es',
      coordinates: {
        latitude: 39.641839106061774,
        longitude: -0.22309136259175136,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Puerto de Sagunto - Embarque Grimaldi Ferry',
    },
    phone: null,
  },
  santander: {
    id: 'santander',
    type: OrderPointType.FERRY,
    name: 'Santander',
    address: {
      label: '39002 Santander, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '39002',
      city: 'Santander',
      countryCode: 'es',
      coordinates: {
        latitude: 43.45877276779651,
        longitude: -3.806612346680211,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Santander Port',
    },
    phone: null,
  },
  tarifa: {
    id: 'tarifa',
    type: OrderPointType.FERRY,
    name: 'Tarifa',
    address: {
      label: '11380 Tarifa, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '11380',
      city: 'Tarifa',
      countryCode: 'es',
      coordinates: {
        latitude: 36.01091624431401,
        longitude: -5.6027618640303105,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Tarifa',
    },
    phone: null,
  },
  valencia: {
    id: 'valencia',
    type: OrderPointType.FERRY,
    name: 'Valencia',
    address: {
      label: '46024 Valencia, ES',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '46024',
      city: 'Valencia',
      countryCode: 'es',
      coordinates: {
        latitude: 39.44579648374354,
        longitude: -0.3249039587246759,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Valencia',
    },
    phone: null,
  },

  /* Sweden */
  gothenburg: {
    id: 'gothenburg',
    type: OrderPointType.FERRY,
    name: 'Gothenburg',
    address: {
      label: '414 51 Gothenburg, SE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '414 51',
      city: 'Gothenburg',
      countryCode: 'se',
      coordinates: {
        latitude: 57.69578313905618,
        longitude: 11.914367270763524,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Gothenburg (Elof Lindälvs Gata)',
    },
    phone: null,
  },
  halmstad: {
    id: 'halmstad',
    type: OrderPointType.FERRY,
    name: 'Halmstad',
    address: {
      label: 'Grenåvägen 22, 302 50 Halmstad, SE',
      street: 'Grenåvägen',
      houseNumber: '22',
      apartmentNumber: null,
      zipCode: '302 50',
      city: 'Halmstad',
      countryCode: 'se',
      coordinates: {
        latitude: 56.64981487606174,
        longitude: 12.854153089269731,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Halmstad',
    },
    phone: {
      areaCode: '+46',
      number: '770575700',
    },
  },
  helsingborg: {
    id: 'helsingborg',
    type: OrderPointType.FERRY,
    name: 'Helsingborg',
    address: {
      label: 'Bredgatan 5, 252 25 Helsingborg, SE',
      street: 'Bredgatan',
      houseNumber: '5',
      apartmentNumber: null,
      zipCode: '252 25',
      city: 'Helsingborg',
      countryCode: 'se',
      coordinates: {
        latitude: 56.040943294720236,
        longitude: 12.69553461042068,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Bredgatan 5',
    },
    phone: {
      areaCode: '+46',
      number: '42106300',
    },
  },
  karlshamn: {
    id: 'karlshamn',
    type: OrderPointType.FERRY,
    name: 'Karlshamn',
    address: {
      label: '374 31 Karlshamn, SE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '374 31',
      city: 'Karlshamn',
      countryCode: 'se',
      coordinates: {
        latitude: 56.158950038549406,
        longitude: 14.816842790529627,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Karlshamn ship docking',
    },
    phone: {
      areaCode: '+46',
      number: '45433690',
    },
  },
  karlskrona: {
    id: 'karlskrona',
    type: OrderPointType.FERRY,
    name: 'Karlskrona',
    address: {
      label: 'Verkövägen 101, 371 65 Lyckeby, SE',
      street: 'Verkövägen',
      houseNumber: '101',
      apartmentNumber: null,
      zipCode: '371 65',
      city: 'Lyckeby',
      countryCode: 'se',
      coordinates: {
        latitude: 56.1646510108508,
        longitude: 15.630635373915954,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Stena Line Karlskrona Ferry terminal',
    },
    phone: {
      areaCode: '+46',
      number: '31858000',
    },
  },
  malmo: {
    id: 'malmo',
    type: OrderPointType.FERRY,
    name: 'Malmo',
    address: {
      label: 'Lappögatan 3B, 211 24 Malmö, SE',
      street: 'Lappögatan',
      houseNumber: '3B',
      apartmentNumber: null,
      zipCode: '211 24',
      city: 'Malmö',
      countryCode: 'se',
      coordinates: {
        latitude: 55.62942120931093,
        longitude: 13.008888016258402,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Lappögatan 3B',
    },
    phone: null,
  },
  nynashamn: {
    id: 'nynashamn',
    type: OrderPointType.FERRY,
    name: 'Nynashamn',
    address: {
      label: '149 30 Nynäshamn, SE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '149 30',
      city: 'Nynäshamn',
      countryCode: 'se',
      coordinates: {
        latitude: 58.90469291120632,
        longitude: 17.955630645310627,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Port of Nynashamn',
    },
    phone: null,
  },
  oskarshamn: {
    id: 'oskarshamn',
    type: OrderPointType.FERRY,
    name: 'Oskarshamn',
    address: {
      label: 'Verkstadsgatan 1, 572 35 Oskarshamn, SE',
      street: 'Verkstadsgatan',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '572 35',
      city: 'Oskarshamn',
      countryCode: 'se',
      coordinates: {
        latitude: 57.263906958919954,
        longitude: 16.45813020202774,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Oskarshamn',
    },
    phone: null,
  },
  oxelosund: {
    id: 'oxelosund',
    type: OrderPointType.FERRY,
    name: 'Oxelösund',
    address: {
      label: 'Skeppargatan 25, 613 31 Oxelösund, SE',
      street: 'Skeppargatan',
      houseNumber: '25',
      apartmentNumber: null,
      zipCode: '613 31',
      city: 'Oxelösund',
      countryCode: 'se',
      coordinates: {
        latitude: 58.667076617261905,
        longitude: 17.10904664653623,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Skeppargatan 25',
    },
    phone: null,
  },
  stockholm: {
    id: 'stockholm',
    type: OrderPointType.FERRY,
    name: 'Stockholm',
    address: {
      label: 'Hamnpirsvägen 14, 115 41 Stockholm, SE',
      street: 'Hamnpirsvägen',
      houseNumber: '14',
      apartmentNumber: null,
      zipCode: '115 41',
      city: 'Stockholm',
      countryCode: 'se',
      coordinates: {
        latitude: 59.35104699501209,
        longitude: 18.11522021553428,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Stockholm',
    },
    phone: {
      areaCode: '+46',
      number: '86663331',
    },
  },
  stromstad: {
    id: 'stromstad',
    type: OrderPointType.FERRY,
    name: 'Stromstad',
    address: {
      label: '452 31 Strömstad, SE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '452 31',
      city: 'Strömstad',
      countryCode: 'se',
      coordinates: {
        latitude: 58.93419358604199,
        longitude: 11.170341091984428,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Stromstad Port',
    },
    phone: {
      areaCode: '+46',
      number: '52662000',
    },
  },
  trelleborg: {
    id: 'trelleborg',
    type: OrderPointType.FERRY,
    name: 'Trelleborg',
    address: {
      label: '231 42 Trelleborg, SE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '231 42',
      city: 'Trelleborg',
      countryCode: 'se',
      coordinates: {
        latitude: 55.37204360167411,
        longitude: 13.15506539014184,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Trelleborg Port',
    },
    phone: {
      areaCode: '+46',
      number: '9001112031',
    },
  },
  umea: {
    id: 'umea',
    type: OrderPointType.FERRY,
    name: 'Umea',
    address: {
      label: '913 22 Holmsund, SE',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '913 22',
      city: 'Holmsund',
      countryCode: 'se',
      coordinates: {
        latitude: 63.680909254733535,
        longitude: 20.3420450835773,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Umea',
    },
    phone: {
      areaCode: '+46',
      number: '90185214',
    },
  },
  varberg: {
    id: 'varberg',
    type: OrderPointType.FERRY,
    name: 'Varberg',
    address: {
      label: 'Östra Hamnvägen 7, 432 44 Varberg, SE',
      street: 'Östra Hamnvägen',
      houseNumber: '7',
      apartmentNumber: null,
      zipCode: '432 44',
      city: 'Varberg',
      countryCode: 'se',
      coordinates: {
        latitude: 57.108812462083904,
        longitude: 12.245784173601937,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Östra Hamnvägen 7',
    },
    phone: null,
  },
  visby: {
    id: 'visby',
    type: OrderPointType.FERRY,
    name: 'Varberg',
    address: {
      label: 'Färjeleden 14, 621 58 Visby, SE',
      street: 'Färjeleden',
      houseNumber: '14',
      apartmentNumber: null,
      zipCode: '621 58',
      city: 'Visby',
      countryCode: 'se',
      coordinates: {
        latitude: 57.63458602072477,
        longitude: 18.28088856047466,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Färjeleden 14',
    },
    phone: null,
  },
  ystad: {
    id: 'ystad',
    type: OrderPointType.FERRY,
    name: 'Ystad',
    address: {
      label: 'Bornholmsgatan 8D, 271 39 Ystad, SE',
      street: 'Bornholmsgatan',
      houseNumber: '8D',
      apartmentNumber: null,
      zipCode: '271 39',
      city: 'Ystad',
      countryCode: 'se',
      coordinates: {
        latitude: 55.42486731725603,
        longitude: 13.828755985356958,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Ystad Havn (færge)',
    },
    phone: null,
  },

  /* Tunisia */
  // TODO

  /* Turkey */
  alsancak: {
    id: 'alsancak',
    type: OrderPointType.FERRY,
    name: 'Alsancak',
    address: {
      label: 'Atatürk Caddesi 87A, 35220 İzmir, TR',
      street: 'Atatürk Caddesi',
      houseNumber: '87A',
      apartmentNumber: null,
      zipCode: '35220',
      city: 'İzmir',
      countryCode: 'tr',
      coordinates: {
        latitude: 38.438973966436386,
        longitude: 27.14073488084564,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Alsancak İskelesi',
    },
    phone: null,
  },
  ambarli: {
    id: 'ambarli',
    type: OrderPointType.FERRY,
    name: 'Ambarli',
    address: {
      label: 'Ambarlı Mah, Ambarlı, Liman Cd., 34524 Avcilar, TR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '34524',
      city: 'Avcilar',
      countryCode: 'tr',
      coordinates: {
        latitude: 40.97108043779589,
        longitude: 28.717909421399867,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Avcilar Terminali',
    },
    phone: null,
  },
  karasu: {
    id: 'karasu',
    type: OrderPointType.FERRY,
    name: 'Karasu',
    address: {
      label: 'Yalı, Batı Karadeniz Cd. No:244, 54500 Karasu/Sakarya, TR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '54500',
      city: 'Karasu',
      countryCode: 'tr',
      coordinates: {
        latitude: 41.11972765288676,
        longitude: 30.67121656970207,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Karasu Port',
    },
    phone: {
      areaCode: '+90',
      number: '2648884400',
    },
  },
  pendik: {
    id: 'pendik',
    type: OrderPointType.FERRY,
    name: 'Pendik',
    address: {
      label:
        'Güzelyalı Mh., Kemikli Dere Mevkii İstanbul Tersane Komutanlığı Yanı, 34903 Pendik/İstanbul, TR',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: '34903',
      city: 'İstanbul',
      countryCode: 'tr',
      coordinates: {
        latitude: 40.861076263461584,
        longitude: 29.272261431394128,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'DFDS Pendik Limanı',
    },
    phone: {
      areaCode: '+90',
      number: '2163925050',
    },
  },

  /* Wales */
  fishguard: {
    id: 'fishguard',
    type: OrderPointType.FERRY,
    name: 'Fishguard',
    address: {
      label: 'SA64 0BU Goodwick, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'SA64 0BU',
      city: 'Goodwick',
      countryCode: 'gb',
      coordinates: {
        latitude: 52.010220765172065,
        longitude: -4.986177812105987,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Fishguard',
    },
    phone: {
      areaCode: '+44',
      number: '3447707070',
    },
  },
  holyhead: {
    id: 'holyhead',
    type: OrderPointType.FERRY,
    name: 'Holyhead',
    address: {
      label: 'Station Street, LL65 1DQ Holyhead, GB',
      street: 'Station Street',
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'LL65 1DQ',
      city: 'Holyhead',
      countryCode: 'gb',
      coordinates: {
        latitude: 53.310313518269965,
        longitude: -4.628863207877415,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Holyhead Ferry Terminal',
    },
    phone: {
      areaCode: '+44',
      number: '3447707070',
    },
  },
  pembroke: {
    id: 'pembroke',
    type: OrderPointType.FERRY,
    name: 'Pembroke',
    address: {
      label: 'SA72 6TD Pembroke Dock, GB',
      street: null,
      houseNumber: null,
      apartmentNumber: null,
      zipCode: 'SA72 6TD',
      city: 'Pembroke Dock',
      countryCode: 'gb',
      coordinates: {
        latitude: 51.69680559727797,
        longitude: -4.953482849006181,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Pembroke',
    },
    phone: null,
  },
} as const satisfies Record<TransitPoint['id'], TransitPoint>;
